var PowerstreamV6 = class extends HTMLElement {
  constructor() {
    super(...arguments)
    this.currentStep = 1
    this.bundles = []
    this.currentIndex = 0

    const stickyBar = document.querySelector(".product-sticky-bar");
    if(stickyBar){
       window.addEventListener('scroll', () => {
        const diySection = document.querySelector(".cust-powerstream-v6");
        const rect = diySection.getBoundingClientRect();
        const diySectionBottomPositionInViewPort = rect.bottom;

        if (diySectionBottomPositionInViewPort < 0) {
          stickyBar.classList.add("active");
        } else {
          stickyBar.classList.remove("active");
        }
      })
    }
  }
  async connectedCallback() {
    document.body.classList.add('has-cust-powerstream-v6')
    this.container = this.querySelector('.product-container')

    this.currencySymbol = this.dataset.currencySymbol
    this.savePerYear = this.container.querySelector('#save-per-year')
    this.capacity = this.container.querySelector('#capacity')
    this.electricityGenerated = this.container.querySelector('#electricity-generated')
    this.electricEquipmentList = this.container.querySelector('#electric-equipment-list')

    var productJson = this.container.querySelector('#product-json')
    if (!productJson || !productJson.innerHTML.length) {
      return
    }

    this.product = JSON.parse(productJson.innerHTML)

    this.productState = {
      available: true,
      soldOut: false,
      onSale: false,
      showUnitPrice: false
    }

    this.formData = {
      items: []
    }
    // "monthElectricPriceBefore": 100,
    // "avgElectricPrice": 4,
    this.chooseForm = {
      longitude: '',
      latitude: '',
      country: '',
      address: '',
      website: 'de',
      familyStructure: 1,
      daytimeElectrPercentage: 50,
      unit: '$',
      bizType: 0,
      electricityPricePercentage: '35',
      solarPanelsPlace: [1]
    }
    this._init()
    this._initMediaTab()
    this._initFormContent()
    this._initLogo()
    this._initScene()
    // this._initProductImages();
    this.updateCurrentVariant()
    this._initGallery()
    this._initVariantButtons()
    
    // 定位链接：url?variant=56327833813373。有 variant 参数则选中对应 bundle，无则默认 bundle 1 并同步 URL
    const params = new URLSearchParams(window.location.search)
    const variantIdFromUrl = (params.get('variant') || '').trim()
    if (variantIdFromUrl && this.container.querySelector('#stream-bundles')) {
      this.container.querySelector('#stream-bundles').click()
      const allBundles = this.container.querySelectorAll('.variant-buttons .variant-button__item')
      const bundleItem = [].find.call(allBundles, (el) => el.dataset.variantId === variantIdFromUrl)
      if (bundleItem && !bundleItem.classList.contains('unavailable')) {
        bundleItem.click()
      }
    } else {
      // 无 variant 参数时默认选中 bundle 1，并同步 URL 为 ?variant=xxx 便于分享
      const firstBundle = this.container.querySelector('.variant-buttons .variant-button__item:not(.unavailable)')
      if (firstBundle) {
        this.container.querySelector('.variant-buttons .variant-button__item.open')?.classList.remove('open')
        firstBundle.classList.add('open')
        this.container.querySelector('#save-per-year').innerHTML = firstBundle.dataset.savePerYear || ''
        this.container.querySelector('#capacity').innerHTML = firstBundle.dataset.capacity || ''
        this.container.querySelector('#electricity-generated').innerHTML = firstBundle.dataset.electricityGenerated || ''
        this.updateCurrentVariant()
        this._setVariantParam(firstBundle.dataset.variantId)
      }
    }


    this._initGoogleMaps()
    this._initSteps()
    this._initCustomSelect()
    this._initUsageSlider()
    this._initPlanTabs()
    this.renderBundle(0)
    this._initBenefitsShowMore()
    this._initQuantityButtons()
    this._initDropdowns()
    this._klarna()
    this._initTabButtons()
    this.initCouponCopy()
    this._initIconPopup()
    this._initStreamBundlesCompareIframePopup()
    this._initHeaderScroll()
    this._initProductParamsSticky()


    this._resizeMediaHeight()
    window.addEventListener('resize', () => {
        this._resizeMediaHeight();
        const guessItems = document.querySelectorAll(".guess-items");
        guessItems.forEach(item => {
          item.style.setProperty("--min-height",  item.querySelectorAll(".accessory-option")[0].offsetHeight + "px"); 
        })
    });
    
    if (this.container.querySelector('.single-media')) {
      this.container.querySelector('#custom-solution')?.click()
    } else if (this.container.querySelector('#stream-bundles')) {
      this.container.querySelector('#stream-bundles').click()
    } else if (this.dataset.enablePreheat === 'true') {
      this._initPreheatGallery()
      this.updateCurrentVariant()
    }
    
    // this.container.querySelector(".buy-now__button button").addEventListener("click", this._addCart.bind(this));
    // const buttonEvents = this.container.querySelectorAll('.taxFreeButton[data-event]')
    const buttonEvents = this.container.querySelectorAll('.custom-buy-button[data-event]')
    buttonEvents.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        this._addCart(btn.dataset.type)
      })
    })

    /** InsCoder WANG.J 2026-02-12 B + Init buy-now subtitle toggle by arrow click **/
    this._initBuyNowSubtitleToggle()
    /** InsCoder WANG.J 2026-02-12 E + Init buy-now subtitle toggle by arrow click **/


    if(this.container.querySelector(".variant-button__item.open")?.classList.contains('solution-variant-item')){
      this.container.querySelectorAll('.product-tab-buttons .button').forEach(btn => {
        btn.classList.remove('active')
      })
      this.container.querySelector('.show-variant-items').classList.add('active')
    }
  }

  _resizeMediaHeight() {
    const media = this.container.querySelector(".active .media-container");
    this.container.style.setProperty("--media-height",media.offsetHeight + "px");
  }

  _initIconPopup() {
    const arrowTriggers = document.querySelectorAll('.product-benefits__item.show-popup')
    arrowTriggers.forEach(arrowTrigger => {
      arrowTrigger.addEventListener('click', () => {
        const popup = document.querySelector('.icon-logo-popup-container')
        const main = document.querySelector('.icon-logo-popup-container .main')
        main.innerHTML = arrowTrigger.querySelector(".description-content").innerHTML;
        const mask = document.querySelector('#icon-logo-mask')
        const popupClone = popup.cloneNode(true)
        const maskClone = mask.cloneNode(true)
        popupClone.classList.add('body-child')
        maskClone.classList.add('body-child')
        document.body.appendChild(maskClone)
        document.body.appendChild(popupClone)
        document.body.style.overflow = 'hidden'
        const close = document.querySelector('.icon-logo-popup-container.body-child .close')
        close.addEventListener('click', () => {
          popupClone.remove()
          maskClone.remove()
          document.body.style.overflow = 'auto'
        })
      })
    })
  }


  /** InsCoder 2026-06-29 B + Help me choose iframe popup **/
  _initStreamBundlesCompareIframePopup() {
    const triggers = this.querySelectorAll('.help-me-choose-iframe-trigger')
    const popup = this.querySelector('.stream-bundles-compare-iframe-popup')
    if (!triggers.length || !popup) return

    const overlay = popup.querySelector('.stream-bundles-compare-iframe-popup__overlay')
    const closeBtn = popup.querySelector('.stream-bundles-compare-iframe-popup__close')
    const iframe = popup.querySelector('iframe')

    const loadIframe = () => {
      if (!iframe || !iframe.dataset.src) return
      if (!iframe.getAttribute('src')) {
        iframe.src = iframe.dataset.src
      }
    }

    const closePopup = () => {
      popup.hidden = true
      popup.setAttribute('aria-hidden', 'true')
      document.body.classList.remove('overflow-hidden')
      if (this._streamBundlesCompareIframeEscHandler) {
        document.removeEventListener('keydown', this._streamBundlesCompareIframeEscHandler)
        this._streamBundlesCompareIframeEscHandler = null
      }
    }

    const openPopup = (e) => {
      e.preventDefault()
      loadIframe()
      popup.hidden = false
      popup.setAttribute('aria-hidden', 'false')
      document.body.classList.add('overflow-hidden')
      this._streamBundlesCompareIframeEscHandler = (event) => {
        if (event.key === 'Escape') closePopup()
      }
      document.addEventListener('keydown', this._streamBundlesCompareIframeEscHandler)
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', openPopup)
    })
    if (overlay) overlay.addEventListener('click', closePopup)
    if (closeBtn) closeBtn.addEventListener('click', closePopup)
  }
  /** InsCoder 2026-06-29 E + Help me choose iframe popup **/


  _initProductParams(){
    if(document.querySelector('.product-tab-buttons .active').id === 'custom-solution'){
      this._updateProductSummary()
    }else if(document.querySelector('.product-tab-buttons .active').id === 'stream-bundles'){
      this.container.querySelector('.variant-buttons .variant-button__item.open').click();
    }
  }
  _initProductParamsSticky() {
    const productParams = this.container.querySelector('.product-params')
    if (!productParams) return
    let ticking = false
    const updateStuck = () => {
      const rect = productParams.getBoundingClientRect()
      const stickyTop = parseFloat(getComputedStyle(productParams).top) || 0
      const stuck = rect.top <= stickyTop + 2
      productParams.classList.toggle('product-params--stuck', stuck)
      ticking = false
    }
    const onScroll = () => {
      if (!ticking) {
        ticking = true
        requestAnimationFrame(updateStuck)
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    updateStuck()
  }

  _initHeaderScroll() {
    const sectionHeader = document.querySelector('#shopify-section-header')
    const mobileNav = document.querySelector('#shopify-section-header .site-header__mobile-nav')
    if (!sectionHeader || !mobileNav) return
    const heroEl = this.container.querySelector('.product-single__media-group') || this.container
    const productTitleEl = this.container.querySelector('.product-single__title')
    let lastScrollY = window.scrollY || window.pageYOffset
    let ticking = false
    const scrollClass = 'v6-header-scroll-hidden'
    const varName = '--v6-header-height'
    const minWidth = 999

    const setHeaderHeightVar = (heightPx) => {
      document.documentElement.style.setProperty(varName, typeof heightPx === 'number' ? heightPx + 'px' : heightPx)
    }

    const isPc = () => window.innerWidth >= minWidth

    const updateHeader = () => {
      if (!isPc()) return
      const scrollY = window.scrollY || window.pageYOffset
      const heroRect = heroEl.getBoundingClientRect()
      const inHeroZone = heroRect.bottom > 80
      const productTitleRect = productTitleEl.getBoundingClientRect()
      const inProductTitleZone = productTitleRect.top < 0

      if (inProductTitleZone) {
        sectionHeader.classList.add(scrollClass)
        setHeaderHeightVar(0)
      } else if (inHeroZone) {
        sectionHeader.classList.remove(scrollClass)
        setHeaderHeightVar(mobileNav.offsetHeight)
      } else {
        if (scrollY > lastScrollY) {
          sectionHeader.classList.add(scrollClass)
          setHeaderHeightVar(0)
        } else {
          sectionHeader.classList.remove(scrollClass)
          setHeaderHeightVar(mobileNav.offsetHeight)
        }
      }
      lastScrollY = scrollY
      ticking = false
    }

    const onScroll = () => {
      if (!isPc()) return
      if (!ticking) {
        ticking = true
        requestAnimationFrame(updateHeader)
      }
    }

    const applyPcState = () => {
      if (isPc()) {
        updateHeader()
      } else {
        sectionHeader.classList.remove(scrollClass)
        setHeaderHeightVar(0)
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    applyPcState()
    window.addEventListener('resize', () => {
      if (isPc()) {
        if (!sectionHeader.classList.contains(scrollClass)) {
          setHeaderHeightVar(mobileNav.offsetHeight)
        }
      } else {
        sectionHeader.classList.remove(scrollClass)
        setHeaderHeightVar(0)
      }
    })
  }


  /** InsCoder WANG.J 2026-02-12 B + Toggle buy-now subtitle (upper) on arrow click **/
  _initBuyNowSubtitleToggle() {
    const arrows = this.container.querySelectorAll('.buy-now__product-title-show-arrow')
    arrows.forEach((arrow) => {
      arrow.setAttribute('role', 'button')
      arrow.setAttribute('tabindex', '0')
      arrow.setAttribute('aria-expanded', 'false')

      const title = arrow.closest('.buy-now__product-title')
      const subtitle = title ? title.nextElementSibling : null

      if (!subtitle || !subtitle.classList.contains('buy-now__product-subtitle-upper')) {
        return
      }

      const toggle = () => {
        const isOpen = subtitle.classList.toggle('is-open')
        arrow.classList.toggle('is-open', isOpen)
        arrow.setAttribute('aria-expanded', isOpen ? 'true' : 'false')

        const buyNowContainer = arrow.closest('.buy-now-container')
        if (buyNowContainer) {
          buyNowContainer.classList.toggle('subtitle-open', isOpen)
        }
      }

      title.addEventListener('click', (e) => {
        e.preventDefault()
        toggle()
      })

    })
  }
  /** InsCoder WANG.J 2026-02-12 E + Toggle buy-now subtitle (upper) on arrow click **/
  initCouponCopy() {
    const couponButtons = this.container.querySelectorAll('[data-coupon-code]')
    
    couponButtons.forEach(button => {
      this.setupCouponClick(button)
    })
  }

  setupCouponClick(button) {
    const couponCode = button.getAttribute('data-coupon-code')
    const copyText = button.getAttribute('data-copy-text') || 'Copy'
    const copiedText = button.getAttribute('data-copied-text') || 'Copied!'
    
    button.addEventListener('click', (e) => {
      e.preventDefault()
      
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(couponCode)
          .then(() => {
            this.showCopySuccess(button, copyText, copiedText)
          })
      }
    })
  }

  showCopySuccess(button, copyText, copiedText) {
    const originalText = button.textContent
    button.textContent = copiedText
    button.classList.add('copied')
    
    setTimeout(() => {
      button.textContent = copyText
      button.classList.remove('copied')
    }, 2000)
  }

  _addCart(is_checkout) {
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.formData)
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (json) {
        if (window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
          window.cart_clear = false
          window.promotionValidate()
        }
        setTimeout( () => {
          if(is_checkout){
            window.location.href = '/checkout'
          }else{
            theme.Cart.prototype._onProductAdded()
            fetch('/cart.js', {
              method: 'GET'
            }).then(function (cart) {
              cart.json().then(function (content) {
                if (document.querySelector('.bf_sticky_bar')) {
                  document.querySelectorAll('.bf_sticky_bar .custom-sticky-bar-inner').forEach(function (parentElem) {
                    parentElem.querySelectorAll('.bar-content').forEach(function (elem) {
                      var from_price = elem.getAttribute('data-from-price')
                      var to_price = elem.getAttribute('data-to-price')
                      if (content['total_price'] >= from_price && content['total_price'] <= to_price) {
                        parentElem.querySelector('.bar-content.active').classList.remove('active')
                        let remainingAmount = theme.Currency.formatMoney(
                          to_price - content['total_price'],
                          theme.moneyFormat
                        )
                        if (elem.querySelector('.remaining-amount'))
                          elem.querySelector('.remaining-amount').innerText = remainingAmount
                        elem.classList.add('active')
                      }
                    })
                  })
                  document
                    .querySelector('body')
                    .style.setProperty('--bf-bar-height', document.querySelector('.bf_sticky_bar').offsetHeight + 'px')
                }
              })
            })
          }
        }, 100)
      })
      .finally(() => {
        const tfModal = document.querySelector('.tax-free-modal')
        if (tfModal) {
          tfModal.style.display = 'none'
        }
        const loading_btn = document.querySelector('.atcButton.loading')
        loading_btn ? loading_btn.classList.remove('loading') : ''
      })
  }

  _initLogo(){
    const arrowTrigger = document.querySelector('#award-logo-block.show_popup')
    if(!arrowTrigger){
      return
    }
    arrowTrigger.addEventListener('click', () => {
      const popup = document.querySelector('.award-logo-popup-container')
      const mask = document.querySelector('#award-logo-mask')
      const popupClone = popup.cloneNode(true)
      const maskClone = mask.cloneNode(true)
      popupClone.classList.add('body-child')
      maskClone.classList.add('body-child')
      document.body.appendChild(maskClone)
      document.body.appendChild(popupClone)
      document.body.style.overflow = 'hidden'
      const close = document.querySelector('.award-logo-popup-container.body-child .close')
      close.addEventListener('click', () => {
        popupClone.remove()
        maskClone.remove()
        document.body.style.overflow = 'auto'
      })
    })

    
    const arrowLeftTrigger = document.querySelector('#award-logo-block .arrow.left');
    if(arrowLeftTrigger){
      arrowLeftTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const container = document.querySelector('#award-logo-block .logo-container');
        document.querySelector('#award-logo-block').classList.remove('next');
        container.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      });
    }

    
    const arrowRightTrigger = document.querySelector('#award-logo-block .arrow.right');
    if(arrowRightTrigger){
      arrowRightTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const container = document.querySelector('#award-logo-block  .logo-container');
        document.querySelector('#award-logo-block').classList.add('next');
        container.scrollTo({
          left: container.scrollWidth,
          behavior: 'smooth'
        });
      });
    }
  }

  _initScene(){
      const scenes = document.querySelector('.installation-scenarios')
      if(!scenes) return;
      // 场景点击
      scenes.addEventListener('click', (e) => {
        if (e.target.classList.contains('installation-scenarios-item')) {
          document.querySelector('.installation-scenarios-item.active').classList.remove('active')
          e.target.classList.add('active');
          if(e.target.querySelectorAll('.bracket-item')[0]){
            e.target.querySelectorAll('.bracket-item')[0].click()
            if(document.querySelector('.panel-unselected.active')){
              document.querySelector('.panel-tabs .panel-tab:nth-child(1)').click()
            }
          }else{
            if(document.querySelector('.bracket-item.active')){ 
              document.querySelector('.bracket-item.active').classList.remove('active')
              document.querySelector('.installation-scenarios-item-title').innerText = ""
              // if(document.querySelector('.panel-unselected:not(.active)')){
              //   document.querySelector('.panel-unselected:not(.active)').click()
              // }
            }

            // const panels = document.querySelectorAll('.panel-block .panel-item')
            // panels.forEach((p, i) => {
            //   p.classList.remove("show-panel");
            //   p.classList.remove("active")
            //   if (!document.querySelector('.bracket-item.active')) {
            //     p.classList.add("show-panel")
            //   }
            // }) 

            this._updateProductSummary()
            this._initProductImages() 

          }
          if(document.querySelector('.installation-scenarios-item.show-less')){
            document.querySelector('.installation-scenarios-item.show-less').style.setProperty("--options-height",  '80px');
            document.querySelector('.installation-scenarios-item.show-less').classList.remove('show-less')
          }
        }
      })

      // 场景下 shore more点击
      const showMores = document.querySelectorAll('.installation-scenarios-item-more')
      showMores.forEach(s => {
        s.addEventListener('click', (e) => {
          const item = e.target.closest(".installation-scenarios-item");
          item.classList.add("show-less");
          item.style.setProperty("--options-height",  item.querySelector(".installation-scenarios-brackets").offsetHeight + 16 + 'px')
        })
      })
      const showLesses = document.querySelectorAll('.brackets-less')
      showLesses.forEach(s => {
        s.addEventListener('click', (e) => {
          const item = e.target.closest(".installation-scenarios-item");
          item.classList.remove("show-less");
          item.style.setProperty("--options-height",  '80px')
        })
      })

      // 支架点击
      const bracketItems = document.querySelectorAll('.bracket-item')
      bracketItems.forEach(b => {
        b.addEventListener('click', (e) => {
          if(document.querySelector('.bracket-item.active')){ 
            document.querySelector('.bracket-item.active').classList.remove('active')
          }
          let selectBracketIds = ''
          if (e.target.classList.contains('bracket-item')) {
            e.target.classList.add('active')
            selectBracketIds = e.target.dataset.ids.split(';')
          } else {
            e.target.parentNode.classList.add('active')
            selectBracketIds = e.target.parentNode.dataset.ids.split(';')
          }
          const panels = document.querySelectorAll('.panel-block .panel-item')
          panels.forEach((p, i) => {
            if (selectBracketIds.includes(p.dataset.variantId)){
              p.classList.add("show-panel")
            } else {
              p.classList.remove("show-panel")
            }
          })
          if(document.querySelectorAll('.panel-block .panel-item.show-panel')[0]){
            document.querySelectorAll('.panel-block .panel-item.show-panel')[0].click() 
          }

          // 设置支架细节图
          const src = b.dataset.detailImage
          const bracketImg = document.querySelector('.bracket-details.media-item-container img')
          bracketImg.src = src
        })
      })





      const panels = document.querySelectorAll('.panel-block .panel-item')
      panels.forEach((p, i) => {
        p.addEventListener('click', (e) => {
          if(p.classList.contains("show-panel")){
            if(document.querySelector('.panel-block .panel-item.active')){
              document.querySelector('.panel-block .panel-item.active').classList.remove('active')
            }
            p.classList.add('active')

            const quantity = document.querySelector('.panel-tabs .panel-tab.active').dataset.quantity
            if(document.querySelector('.panel-block .panel-item.active .item-content-vars div[data-quantity="' + quantity + '"]')){
              document.querySelector('.panel-block .panel-item.active .item-content-vars div[data-quantity="' + quantity + '"]').click()
            }else{
              console.log('no quantity');
            }
      
            if(document.querySelector('.bracket-item.active')){
              document.querySelector('.panel-block .panel-item.active .bracket').innerText = document.querySelector('.bracket-item.active').dataset.title
              const ratio = document.querySelector('.bracket-item.active').dataset.bracketPanelRatio?document.querySelector('.bracket-item.active').dataset.bracketPanelRatio:1;
              const showQuantity = parseInt(document.querySelector('.panel-block .panel-item.active .item-content-vars div.active').innerText) * parseFloat(ratio);
              document.querySelector('.panel-block .panel-item.active .quantity').innerText = showQuantity + " ×"
              document.querySelector('.installation-scenarios-item-title').innerText = document.querySelector('.bracket-item.active').dataset.title + " × " + showQuantity
            }else{
              document.querySelector('.installation-scenarios-item-title').innerText = ""
              document.querySelector('.panel-block .panel-item.active .bracket').innerText = ""
              document.querySelector('.panel-block .panel-item.active .quantity').innerText = ""
            }
            
            this._updateProductSummary()
            this._initProductImages()
          }
        })
      })

     const unselecteds = this.container.querySelectorAll(".panel-unselected");
     if(unselecteds.length > 0){
      unselecteds.forEach(unselected => {
        unselected.addEventListener('click', (e) => {
          document.querySelectorAll('.panel-block .panel-item.active').forEach(item => {
            item.classList.remove("active");
          })
          if(document.querySelector('.none-product:not(.active)')){
            document.querySelector('.none-product:not(.active)').click()
          }
        });
      });
    }

    const panelTabs = document.querySelectorAll('.panel-tabs .panel-tab');
    panelTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        if(document.querySelector('.panel-tabs .panel-tab.active')){
          document.querySelector('.panel-tabs .panel-tab.active').classList.remove('active')
        }
        e.target.classList.add('active')
        if(!document.querySelector('.panel-block .panel-item.active') && !e.target.classList.contains('panel-unselected')){
          document.querySelector('.panel-block .panel-item').classList.add('active')
        }
        const quantity = e.target.dataset.quantity
        if(document.querySelector('.panel-block .panel-item.active .item-content-vars div[data-quantity="' + quantity + '"]')){
          document.querySelector('.panel-block .panel-item.active .item-content-vars div[data-quantity="' + quantity + '"]').click();
        }else{
          console.log('no quantity');
        }
        if(!e.target.classList.contains("panel-unselected") && document.querySelector('.installation-scenarios .active.none-product')){
          document.querySelectorAll('.installation-scenarios .installation-scenarios-item')[0].click()
        }
      });
    });

      document.querySelectorAll('.panel-block .item-content-vars div').forEach(q => {
        q.addEventListener('click', (e) => {
          e.stopPropagation()
          document.querySelector('.panel-block .panel-item.active .item-content-vars div.active').classList.remove('active')
          e.target.classList.add('active')
          if(document.querySelector('.bracket-item.active')){
            const ratio = document.querySelector('.bracket-item.active').dataset.bracketPanelRatio?document.querySelector('.bracket-item.active').dataset.bracketPanelRatio:1;
            const showQuantity = parseInt(document.querySelector('.panel-block .panel-item.active .item-content-vars div.active').innerText) * parseFloat(ratio);
            document.querySelector('.panel-block .panel-item.active .quantity').innerText = showQuantity + " ×"
          }else{
            document.querySelector('.panel-block .panel-item.active .quantity').innerText = ""
          }
          // document.querySelector('.panel-block .panel-item.active').click();
          this._updateProductSummary()
          this._initProductImages()
        })
      })




      const guessItems = document.querySelectorAll(".guess-items");
      guessItems.forEach(item => {
        const guessMore = item.querySelector('.guess-show-more')
        const guessLess = item.querySelector('.guess-show-less')
        item.style.setProperty("--min-height",  item.querySelectorAll(".accessory-option")[0].offsetHeight + "px"); 
        guessMore.addEventListener('click', () => {
          item.classList.add("show-less") 
        })
        guessLess.addEventListener('click', () => {
          item.classList.remove("show-less") 
        })
      })
  
  }


  _initMediaTab(){
    const tabItems = document.querySelectorAll('.cust-powerstream-v6 .media-tab .tab-item');

    const initSellingPointsSlider = (container) => {
      if (!container) return
      const slider = container.querySelector('[data-selling-points-slider]')
      if (!slider) return
      let flkty = Flickity.data(slider)
      if (!flkty) {
        const selling_slider_options = JSON.parse(slider.getAttribute('data-flickity-config') || '{}')
        flkty = new Flickity(slider, selling_slider_options)
        flkty.element.classList.add('rendered')
        const prevBtn = container.querySelector('.selling__arrows .btn-previous')
        const nextBtn = container.querySelector('.selling__arrows .btn-next')
        if (prevBtn) prevBtn.onclick = () => flkty.previous()
        if (nextBtn) nextBtn.onclick = () => flkty.next()
        flkty.on('select', () => {
          const thumbs = container.querySelectorAll('.selling-points__thumbnail-block')
          thumbs.forEach(el => el.classList.remove('selected'))
          if (thumbs[flkty.selectedIndex]) thumbs[flkty.selectedIndex].classList.add('selected')
        })
        // 缩略图点击切换
        const thumbBlocks = container.querySelectorAll('.selling-points__thumbnail-block')
        thumbBlocks.forEach((thumb, idx) => {
          thumb.addEventListener('click', () => {
            flkty.select(idx)
          })
        })
      }
    }

    tabItems.forEach(tab => {
      tab.addEventListener('click', function() {
        const scope = this.closest('.product-single__media.has-embed-image') || this.closest('.product-single__media-recommend')
        if (!scope) return

        scope.querySelectorAll('.tab-item').forEach(t => t.classList.remove('active'))
        scope.querySelectorAll('.media-item-container').forEach(m => m.classList.remove('active'))

        this.classList.add('active')
        this.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })

        const targetClass = this.getAttribute('data-target')
        const targetEl = scope.querySelector('.' + targetClass)
        if (targetEl) targetEl.classList.add('active')

        if (targetClass === 'selling-points') {
          initSellingPointsSlider(scope.querySelector('.selling-points.active'))
        } else if (targetClass === 'recommend-selling-points') {
          initSellingPointsSlider(scope.querySelector('.recommend-selling-points.active'))
        }
      })
    })
  }

  _resetMediaTabsToFirst(scope) {
    if (!scope) return
    const tabs = scope.querySelectorAll('.media-tab .tab-item')
    const items = scope.querySelectorAll('.media-item-container')
    tabs.forEach(t => t.classList.remove('active'))
    items.forEach(m => m.classList.remove('active'))
    if (tabs.length) tabs[0].classList.add('active')
    if (items.length) items[0].classList.add('active')
  }

  /**
   * Flickity 在初始化时若 carousel 在 display:none 的父节点内，会得到 0 高度；
   * 只有在 window resize 时才会重新计算。切换到显示 recommend 区块后，主动触发一次 resize。
   */
  _resizeProductCarouselWhenVisible() {
    if (!this.flickityInstance) return
    if (this.flickityInstance && typeof this.flickityInstance.resize === 'function') {
      this.flickityInstance.reloadCells();
      this.flickityInstance.resize()
    }
  }

  _init() {
    const target = this.container.querySelector('.buy-now-container-fixed')
    const buybutton = this.container.querySelector('.custom-solution-buy-button')
    const target1 = this.container.querySelector('.buy-now__button-fixed')
    const buybutton1 = this.container.querySelector('.stream-bundles-buy-button')
    const bundletarget = this.container.querySelector('.plan-actions')
    const bundlebuybutton = this.container.querySelector('.bundle-buy-container')
    const tab_contents = this.container.querySelector('.product-tab-contents')
    const install_services = this.container.querySelectorAll(".cust-install__service")

    install_services.forEach(install_service => {
      var inputItems = install_service.querySelectorAll(".install-checkbox_input");
      inputItems.forEach(input_item => {
        input_item.addEventListener('change', ()=>{
          inputItems.forEach(item => {
            if(item != input_item){
              item.checked = false;
            }
          })
        })
      })
    })

    /** InsCoder WANG.J 2026-07-10 B + Slide-in/out animation for fixed buy-now containers **/
    const slideOutAndRemoveFixed = (el) => {
      if (!el || !el.classList.contains('fixed') || el.classList.contains('is-leaving')) return
      el.classList.add('is-leaving')
      const onEnd = (e) => {
        if (e && e.propertyName !== 'transform') return
        el.classList.remove('fixed', 'is-leaving')
        el.removeEventListener('transitionend', onEnd)
      }
      el.addEventListener('transitionend', onEnd)
      // 兜底：transitionend 在某些情况下不会触发（如 display:none），加一个超时保护
      setTimeout(() => {
        if (el.classList.contains('is-leaving')) {
          el.classList.remove('fixed', 'is-leaving')
          el.removeEventListener('transitionend', onEnd)
        }
      }, 400)
    }

    const slideInFixed = (el) => {
      if (!el || el.classList.contains('fixed')) return
      // 第 1 步：先把元素藏到屏幕下方（is-entering 控制），但不要触发过渡
      el.classList.add('is-entering')
      // 第 2 步：下一帧把 is-entering 切到 fixed，transform 由 100% 过渡到 0
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.classList.add('fixed')
          setTimeout(() => {
            el.classList.remove('is-entering')
          },400)
        })
      })
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 元素进入视口：先触发滑出动画，结束后再移除 .fixed
            slideOutAndRemoveFixed(buybutton)
          } else {
            // 元素离开视口：从底部滑入
            buybutton.parentNode.style.setProperty('--fixed-height', buybutton.clientHeight + 'px')
            buybutton.classList.remove('is-leaving')
            slideInFixed(buybutton)
            buybutton.style.setProperty('--fixed-width', tab_contents.clientWidth + 'px')
          }
        })
      },
      {
        root: null,
        threshold: 1
      }
    )

    if (target && buybutton) {
      observer.observe(target)
    }

    if(target1){
      const observer1 = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              slideOutAndRemoveFixed(buybutton1)
            } else {
              buybutton1.parentNode.style.setProperty('--fixed-height', buybutton1.clientHeight + 'px')
              buybutton1.classList.remove('is-leaving')
              slideInFixed(buybutton1)
              buybutton1.style.setProperty('--fixed-width', tab_contents.clientWidth + 'px')
            }
          })
        },
        {
          root: null,
          threshold: 0,
          rootMargin: '200px 0px 0px 0px'
        }
      )

      observer1.observe(target1)
    }
    /** InsCoder WANG.J 2026-07-10 E + Slide-in/out animation for fixed buy-now containers **/

    if (bundlebuybutton) {
      const observer1 = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              bundlebuybutton.classList.remove('fixed')
            } else {
              bundlebuybutton.parentNode.style.setProperty('--fixed-height', bundlebuybutton.clientHeight + 'px')
              bundlebuybutton.classList.add('fixed')
              bundlebuybutton.style.setProperty('--fixed-width', tab_contents.clientWidth + 'px')
            }
          })
        },
        {
          root: null,
          threshold: 1
        }
      )

      observer1.observe(bundletarget)
    }



    const product_title = this.container.querySelector('.product-form .product-fixed-subtitle')
    const product_form = this.container.querySelector('.product-form')
    const product_form_fixed = this.container.querySelector('.product-form .product-fixed')


    if (product_form) {
      const observer_form = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio === 0) {
              // product_form.classList.add('fixed')
              product_form.style.setProperty('--product-fixed-height', product_form_fixed.offsetHeight + 'px')
            } else {
              product_form.classList.remove('fixed')
            }
          })
        },
        {
          root: null,
          threshold: 0
        }
      )

      observer_form.observe(product_title)

      let lastScrollTop = 0;

      window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
         product_form.classList.add("active")
        } else if (scrollTop < lastScrollTop) {
         product_form.classList.remove("active")
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
      });

    }
    this._initProductConfigurator()
  }

  _initProductConfigurator() {
    // 帮助横幅点击事件
    const helpBanner = this.container.querySelector('.configurator-help-banner')

    const helpCloseIcon = this.container.querySelectorAll('.help-me-choose-close-icon')
    const helpOverlay = this.container.querySelector('.help-me-choose-overlay')
    if (helpBanner) {
      const helpEle = document.querySelector("[data-tab-id='help-me-choose']")
      helpBanner.addEventListener('click', (e) => {
        if(helpBanner.dataset.link){
          window.open(helpBanner.dataset.link)
        }else{
        // const helpMeChooseTab = this.container.querySelector('#help-me-choose');
        // if (helpMeChooseTab) {
        //   helpMeChooseTab.click();
        // }
          helpEle.classList.add('popup-open')
        }
      })
      helpCloseIcon.forEach((item) => {
        item.addEventListener('click', () => {
          helpEle.classList.remove('popup-open')
        })
      })
      helpOverlay.addEventListener('click', () => {
        helpEle.classList.remove('popup-open')
      })
    }

    const scenarioOptions = this.container.querySelectorAll('.scenario-option input')
    if (scenarioOptions.length) {
      scenarioOptions.forEach((option) => {
        option.addEventListener('change', () => {
          const selectedScenario = option.value
          const bracketsTitle = this.container.querySelector('#bracket-title')
          if (bracketsTitle) {
            bracketsTitle.textContent =
              bracketsTitle.dataset.bracketTitle +
              ' ' +
              selectedScenario.charAt(0).toUpperCase() +
              selectedScenario.slice(1)
          }

          const brackets = this.container.querySelectorAll('.bracket-options .bracket-option')
          brackets.forEach((bracket) => {
            const checkbox = bracket.querySelector('input[type="checkbox"]')
            if (checkbox && checkbox.checked) {
              checkbox.checked = false
            }
          })
          this._updateProductSummary()
          this._initProductImages()
        })
      })
      // scenarioOptions[0].click();
    }

    const quantityRadios = this.container.querySelectorAll('.quantity-selector input[type="radio"]')
    if (quantityRadios.length) {
      quantityRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const parentSelector = radio.closest('.quantity-selector')
          if (!parentSelector) return

          if (parentSelector.dataset.required) {
            const quantity_selectors = this.container.querySelectorAll('.quantity-selector:not([data-required])')
            const current_value = parentSelector.querySelector('input[type="radio"]:checked').value
            quantity_selectors.forEach((item) => {
              const radios = item.querySelectorAll('input[type="radio"]')
              radios.forEach((raItem, index) => {
                if (index == 0) {
                  radios[0].checked = true
                  item.querySelectorAll('.quantity-btn').forEach((btn) => {
                    btn.classList.remove('active')
                  })
                }
                if (raItem.value > 6 - current_value) {
                  raItem.disabled = true
                } else {
                  raItem.disabled = false
                }
              })
            })
          }

          parentSelector.querySelectorAll('.quantity-btn').forEach((btn) => {
            btn.classList.remove('active')
          })

          const currentBtn = radio.nextElementSibling
          if (currentBtn) {
            currentBtn.classList.add('active')
          }

          this._updateProductSummary()
          this._initProductImages()
        })
      })

      quantityRadios.forEach((radio) => {
        if (radio.checked) {
          const btn = radio.nextElementSibling
          if (btn) {
            btn.classList.add('active')
          }
        }
      })
    }

    const panelOptions = this.container.querySelectorAll('.panel-option')
    if (panelOptions.length) {
      panelOptions.forEach((option) => {
        const checkbox = option.querySelector('input[type="checkbox"]')
        checkbox.addEventListener('change', () => {
          if (checkbox.checked) {
            const checkedPanelOptions = this.container.querySelectorAll('.panel-option input[type="checkbox"]:checked')
            if (checkedPanelOptions.length == 1) {
              checkedPanelOptions[0].value = 10
            }
          } else if (checkbox.value !== 100) {
            checkbox.value = 1
          }
          this._updateProductSummary()
          this._initProductImages()
        })
      })
    }

    const accessoryOptions = this.container.querySelectorAll('.bracket-option,.accessory-option,.install-block,.battery-option')
    if (accessoryOptions.length) {
      accessoryOptions.forEach((option) => {
        const checkbox = option.querySelector('input[type="checkbox"]')
        checkbox.addEventListener('change', () => {
          const accessoriesOption = checkbox.closest(".accessory-option-checked")
          if (checkbox.checked && accessoriesOption && parseInt(accessoriesOption.querySelector('.quantity-value').textContent) == 0) {
            accessoriesOption.querySelector('.quantity-value').innerText = 1
          }
          if(checkbox.closest(".battery-option") && checkbox.checked){
            const quantityValue = parseInt(checkbox.closest(".battery-option").querySelector('.quantity-value').innerText)
            if(quantityValue > document.querySelector(".battery-options-info .num").textContent){
              checkbox.checked = false;
              return;
            }
          }
          if(option.closest(".guess-items-v2")){
            this._updatePrice()
            this._updateRecommendImages()
          }else{
            this._updateProductSummary()
            this._initProductImages()
          }
        })
      })
    }

    if (this.dataset.enablePreheat !== 'true') {
      this._updateProductSummary()
      this._initProductImages()
    }
  }

  _initDropdowns() {
    const dropdownTriggers = this.container.querySelectorAll('.dropdown-trigger')

    let overlay = null

    const createOverlay = () => {
      if (!overlay) {
        overlay = document.createElement('div')
        overlay.className = 'dropdown-overlay'
        overlay.style.position = 'fixed'
        overlay.style.top = '0'
        overlay.style.left = '0'
        overlay.style.right = '0'
        overlay.style.bottom = '0'
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
        overlay.style.zIndex = '999'
        overlay.style.display = 'none'
        document.body.appendChild(overlay)

        overlay.addEventListener('click', () => {
          closeAllDropdowns()
        })
      }
      return overlay
    }

    const closeAllDropdowns = () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.classList.remove('active')
        const menu = trigger.previousElementSibling
        if (menu && menu.classList.contains('battery-dropdown-menu')) {
          menu.style.display = 'none'
        }
      })

      if (overlay) {
        overlay.style.display = 'none'
      }
    }

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.battery-dropdown-menu') && !e.target.closest('.dropdown-trigger')) {
        closeAllDropdowns()
      }
    })

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const menu = trigger.previousElementSibling
        if (!menu || !menu.classList.contains('battery-dropdown-menu')) {
          return
        }

        const isActive = trigger.classList.contains('active')

        closeAllDropdowns()

        if (!isActive) {
          trigger.classList.add('active')
          menu.style.display = 'block'
          menu.style.zIndex = '1000'

          if (window.innerWidth <= 749) {
            const overlay = createOverlay()
            overlay.style.display = 'block'
          }
        }
      })
    })

    const dropdownItems = this.container.querySelectorAll('.dropdown-item')

    dropdownItems.forEach((item) => {
      const newItem = item.cloneNode(true)
      item.parentNode.replaceChild(newItem, item)

      newItem.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        const menu = newItem.closest('.battery-dropdown-menu')
        const trigger = menu.nextElementSibling
        const batteryTitle = trigger.querySelector('.battery-title')

        const batteryOption = trigger.closest('.battery-option')

        const title = newItem.getAttribute('data-title')
        const power = newItem.getAttribute('data-power')
        const mppt = newItem.getAttribute('data-mppt')

        const subtitle = menu.previousElementSibling
        subtitle.querySelector('.battery-product').innerText = title
        subtitle.querySelector('.battery-power').innerText = (power / 1000 + "").replace('.',',');
        if(subtitle.querySelector('.battery-mppt')){
          subtitle.querySelector('.battery-mppt').innerText = mppt
        }

        menu.querySelectorAll('.dropdown-item').forEach((i) => {
          i.classList.remove('selected')
          i.querySelector('.check-icon').style.display = 'none'
        })
        newItem.classList.add('selected')
        const checkIcon = newItem.querySelector('.check-icon')
        if (checkIcon) {
          checkIcon.style.display = 'block'
        }

        const currentTitle = batteryTitle.innerHTML
        const specMatch = currentTitle.match(/\(.*\)/)
        const spec = specMatch ? specMatch[0] : ''
        // batteryTitle.innerHTML = `${title} ${spec}`

        batteryOption.dataset.variantId = newItem.dataset.variantId
        batteryOption.dataset.price = newItem.dataset.price
        batteryOption.dataset.embedImage = newItem.dataset.embedImage
        if (newItem.dataset.mppt) {
          batteryOption
            .closest('.configurator-section')
            .querySelectorAll('[data-mppt-value]')
            .forEach((item) => {
              item.dataset.mppt = newItem.dataset.mppt
            })
        }

        closeAllDropdowns()

        this._updateProductSummary()
      })
    })

    this.container.querySelectorAll('.dropdown-item').forEach((item) => {
      const menu = item.closest('.battery-dropdown-menu')
      const trigger = menu.previousElementSibling
      const batteryTitle = trigger.querySelector('.battery-product')

      if (batteryTitle.textContent.includes(item.getAttribute('data-value'))) {
        item.classList.add('selected')
        const checkIcon = item.querySelector('.check-icon')
        if (checkIcon) {
          checkIcon.style.display = 'block'
        }
      }
    })


    document.querySelectorAll("div[data-tab-id]").forEach(item => {
      item.addEventListener('click', (e) => {
        const target = e.target
        const toggleBtn = target.closest('.bundle-list__addons-toggle')
        if (toggleBtn) {
          const addons = toggleBtn.closest('.bundle-list__addons')
          if (!addons || !addons.dataset.addonsFor) return
          const key = addons.dataset.addonsFor
          const viewLess = this.dataset.addonsViewLess || 'View less'
          const viewMore = this.dataset.addonsViewMore || 'View more'
          this.container.querySelectorAll(`.bundle-list__addons[data-addons-for="${key}"]`).forEach(el => {
            el.classList.toggle('bundle-list__addons--collapsed')
            el.classList.toggle('bundle-list__addons--expanded')
            const t = el.querySelector('.bundle-list__addons-toggle .bundle-list__addons-toggle-text')
            if (t) t.textContent = el.classList.contains('bundle-list__addons--expanded') ? viewLess : viewMore
          })
          return
        }
        if(target.classList.contains('bundle-list__addon-action')){
          const variantId = target.dataset.variantId
          const accessoriesOption = item.querySelector(`.accessory-option[data-variant-id="${variantId}"]`)
          if(target.classList.contains('add')){
            accessoriesOption.querySelector(".quantity-value").textContent = 1;
            accessoriesOption.querySelector('input[type="checkbox"]').checked = true;
            accessoriesOption.querySelector('input[type="checkbox"]').dispatchEvent(new Event('change'));
          }else{
            accessoriesOption.querySelector(".quantity-value").textContent = 0;
            accessoriesOption.querySelector('input[type="checkbox"]').checked = false;
            accessoriesOption.querySelector('input[type="checkbox"]').dispatchEvent(new Event('change'));
          }
        }
      })
    });
  }
  
  _setupAddonsViewMore(container, key) {
    if (!container) return
    container.removeAttribute('data-addons-for')
    container.querySelectorAll('.bundle-list__addons-toggle').forEach(el => el.remove())
    container.classList.remove('bundle-list__addons--collapsed', 'bundle-list__addons--expanded')
    const cards = container.querySelectorAll('.bundle-list__card--addon')
    if (cards.length <= 3) return
    container.dataset.addonsFor = key
    container.classList.add('bundle-list__addons--collapsed')
    const viewMore = this.dataset.addonsViewMore || 'View more'
    const toggle = document.createElement('button')
    toggle.type = 'button'
    toggle.className = 'bundle-list__addons-toggle'
    toggle.innerHTML = `<span class="bundle-list__addons-toggle-text">${viewMore}</span><span class="bundle-list__addons-toggle-icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="8" viewBox="0 0 15 8" fill="none"><path d="M13.334 0.833008L7.08398 7.08301L0.833984 0.833007" stroke="#83868D" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`
    container.appendChild(toggle)
  }

  // update custom section
  _updateProductSummary() {
    const badges_container = this.container.querySelector('.basic-images');
    badges_container.querySelectorAll(".badge-item").forEach(item => item.remove());

    this.formData.items = []
    var priceFormat = theme.priceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat

    let totalPrice = 0
    let totalComparePrice = 0
    let batteriesPower = 0
    let batteriesPrice = 0
    let batteriesComparePrice = 0
    let batteriesMPPT = 0
    const batteryOptions = this.container.querySelectorAll('.battery-option')
    let num = 1,hasBracket = false, totalQuantity = 0;
    batteryOptions.forEach((option) => {
      const radio = option.querySelector('input[type="checkbox"]:checked')
      const title = option.querySelector(".battery-product").innerText
      if (radio) {
        const quantity = parseInt(option.querySelector(".quantity-value").innerText)
        if (quantity > 0) {
          totalQuantity += quantity;
          batteriesPower += (quantity * parseFloat(option.dataset.power)) / 1000
          batteriesPrice += quantity * parseFloat(option.dataset.price)
          batteriesComparePrice += quantity * parseFloat(option.dataset.comparePrice)
          const variantImg = option.querySelector(".variant-img")?option.querySelector(".variant-img").src: option.dataset.embedImage? option.dataset.embedImage : ""
          this.formData.items.push({
            id: option.dataset.variantId,
            title: title,
            quantity: quantity,
            variantImg: variantImg,
            group: 'main',
            list: true
          })

          const mppt = option.querySelector('.dropdown-item.selected[data-mppt]')
          if (mppt) {
            batteriesMPPT = quantity * parseInt(mppt.dataset.mppt)
            badges_container.insertAdjacentHTML("beforeend",`<span class="battery-badge-1 badge-item">${title} ×${quantity}</span>`)
          }else{
            badges_container.insertAdjacentHTML("beforeend",`<span class="battery-badge-2 badge-item">${title} ×${quantity}</span>`)
          }
        }
      }
    })
    
    if(document.querySelector(".battery-options-info .num")){
      document.querySelector(".battery-options-info .num").textContent = 6 - totalQuantity;
    }
    if(batteriesPrice > 0){
      num += 1;
    }
    
    if(totalQuantity == 6){
      document.querySelectorAll(".battery-options-list .quantity-increase").forEach(item => item.classList.add('disabled'));
    }else{
      document.querySelectorAll(".battery-options-list .quantity-increase").forEach(item => item.classList.remove('disabled'));
    }
    
    if(this.container.querySelector('#electricity-generated')){
      this.container.querySelector('#electricity-generated').innerHTML = (batteriesPower * 1000).toLocaleString('fr-FR') + " kWh"
    }

    if(this.container.querySelector('#batteries-power')){
      this.container.querySelector('#batteries-power').textContent = (batteriesPower.toFixed(2)+"").replace('.',',');
    }
    const mppt_name = this.container.querySelector('#mppt-name')
    if (mppt_name) {
      mppt_name.textContent = batteriesMPPT
    }
    if(this.container.querySelector('#batteries-price')){
      this.container.querySelector('#batteries-price').textContent = theme.Currency.formatMoney(
        batteriesPrice,
        priceFormat
      ).replace("EUR", "")
      totalPrice += batteriesPrice
      totalComparePrice += batteriesComparePrice
    }

    let panelsPower = 0
    let panelsPrice = 0
    let panelsSavePrice = 0
    let panelsComparePrice = 0

    const panelActive= this.container.querySelector('.panel-items .panel-item.active')
    let panelQuantity = 0,panelShowQuantity = 0
    if(panelActive){
      panelQuantity = parseInt(panelActive.querySelector('.item-content-vars .active').dataset.quantity)
      panelShowQuantity = parseInt(panelActive.querySelector('.item-content-vars .active').dataset.showQuantity)

      panelsPower += parseFloat(panelActive.dataset.power) * panelQuantity
      panelsPrice += parseFloat(panelActive.dataset.price) * panelQuantity
      panelsSavePrice += parseFloat(panelActive.dataset.savePrice) * panelQuantity
      panelsComparePrice += parseFloat(panelActive.dataset.comparePrice) * panelQuantity

      const variantImg = panelActive.querySelector(".variant-img")?panelActive.querySelector(".variant-img").src: panelActive.dataset.embedImage? panelActive.dataset.embedImage : ""
      this.formData.items.push({
        id: panelActive.dataset.variantId,
        title: panelActive.querySelector('.item-content-title').innerText,
        quantity: panelQuantity,
        showQuantity: panelShowQuantity,
        variantImg: variantImg,
        group: 'main',
        list: true
      })

      // this.container.querySelector('#panels-power').textContent = panelsPower;
      let displayPower = panelsPower > 1000 ? panelsPower.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : panelsPower

      if(this.container.querySelector('#panels-power')){
        this.container.querySelector('#panels-power').textContent = displayPower
        this.container.querySelector('#panels-price').textContent = theme.Currency.formatMoney(
          panelsPrice,
          priceFormat
        ).replace("EUR", "")
        totalPrice += panelsPrice
        totalComparePrice += panelsComparePrice
      }

      this.container.querySelector('#save-per-year').innerHTML = panelsSavePrice/100 + " €"
      this.container.querySelector('#capacity').innerHTML = displayPower + " kWh"
      

      badges_container.insertAdjacentHTML("beforeend",`<span class="panel-badge badge-item">${panelActive.querySelector('.item-content-title').innerText} ×${panelShowQuantity}</span>`)
    }else{
      

      num -= 1;

      if(this.container.querySelector('#panels-power')){
        this.container.querySelector('#panels-power').textContent = 0
        this.container.querySelector('#panels-price').textContent = theme.Currency.formatMoney(
          0,
          priceFormat
        ).replace("EUR", "")
      }
      this.container.querySelector('#save-per-year').innerHTML = "0 €"
      this.container.querySelector('#capacity').innerHTML = 0 + " kWh"
    
    }
    


    let brackesPrice = 0
    let brackesComparePrice = 0
    const brackeActive = this.container.querySelector('.bracket-item.active')
    if(brackeActive && panelQuantity){
      hasBracket = true;
      num += 1;
      const ratio = brackeActive.dataset.bracketPanelRatio?brackeActive.dataset.bracketPanelRatio:1;
      const showQuantity = panelShowQuantity * parseFloat(ratio);
      brackesPrice += parseFloat(brackeActive.dataset.price) * showQuantity
      brackesComparePrice += parseFloat(brackeActive.dataset.comparePrice) * showQuantity

      const variantImg = brackeActive.dataset.embedImage? brackeActive.dataset.embedImage : brackeActive.querySelector(".variant-img")?brackeActive.querySelector(".variant-img").src:""
      this.formData.items.push({
        id: brackeActive.dataset.variantId,
        title: panelActive.querySelector('.bracket').innerText,
        quantity: showQuantity,
        showQuantity: showQuantity,
        variantImg: variantImg,
        group: 'main',
        list: true
      })

      totalPrice += brackesPrice
      totalComparePrice += brackesComparePrice

      
      badges_container.insertAdjacentHTML("beforeend",`<span class="bracket-badge badge-item bracket-order-${brackeActive.dataset.bracketBadge}">×${showQuantity}</span>`)
    }


    let accessoriesPrice = 0
    let accessoriesComparePrice = 0
    const accessoriesCheckbox = this.container.querySelectorAll('[data-tab-id="custom-solution"] .accessory-options .accessory-option>input[type="checkbox"]:checked')
    accessoriesCheckbox.forEach((checkbox) => {
      const accessoriesOption = checkbox.closest('.accessory-option')
      const quantity = parseInt(accessoriesOption.querySelector('.quantity-value').textContent)
      accessoriesPrice += parseFloat(accessoriesOption.dataset.price) * quantity
      accessoriesComparePrice += parseFloat(accessoriesOption.dataset.comparePrice) * quantity

      const installService = accessoriesOption.nextElementSibling;
      if(installService && installService.classList.contains("cust-install__service")){
        const checkboxItemInput = installService.querySelector(".install-checkbox_input:checked");
        if(checkboxItemInput){
          const checkboxItem = checkboxItemInput.closest(".install-block");
          const quantityCheckItem = parseInt(checkboxItem.querySelector('.quantity-value').textContent);
          accessoriesPrice += parseFloat(checkboxItem.dataset.price) * quantity
          accessoriesComparePrice += parseFloat(checkboxItem.dataset.comparePrice) * quantity
          const variantImg = checkboxItem.querySelector(".variant-img")?checkboxItem.querySelector(".variant-img").src: checkboxItem.dataset.embedImage? checkboxItem.dataset.embedImage : ""
          this.formData.items.push({
            id: checkboxItem.dataset.variantId,
            title: checkboxItem.querySelector('.install-content-title').innerText,
            quantity: quantityCheckItem,
            variantImg: variantImg,
            price: parseFloat(checkboxItem.dataset.price),
            comparePrice: parseFloat(checkboxItem.dataset.comparePrice),
            group: 'addon'
          })
        }
      }
      
      const variantImg = accessoriesOption.querySelector(".variant-img")?accessoriesOption.querySelector(".variant-img").src: accessoriesOption.dataset.embedImage? accessoriesOption.dataset.embedImage : ""
      this.formData.items.push({
        id: accessoriesOption.dataset.variantId,
        title: accessoriesOption.querySelector('.accessory-name').innerText,
        quantity: quantity,
        variantImg: variantImg,
        price: parseFloat(accessoriesOption.dataset.price),
        comparePrice: parseFloat(accessoriesOption.dataset.comparePrice),
        group: 'addon'
      })

      badges_container.insertAdjacentHTML("beforeend",`<span class="accessory-badge badge-item accessory-order-${accessoriesOption.dataset.accessoryBadge}">×${quantity}</span>`)
    
    })
    if(accessoriesCheckbox.length > 0){
      num += 1;
    }

    if(this.container.querySelector('#accessories-price')){
      this.container.querySelector('#accessories-price').textContent = theme.Currency.formatMoney(
        accessoriesPrice,
        priceFormat
      ).replace("EUR", "")
    }
    totalPrice += accessoriesPrice
    totalComparePrice += accessoriesComparePrice

    this.container.querySelector('.custom-solution-buy-button .product-price .price').textContent =
      theme.Currency.formatMoney(totalPrice, priceFormat).replace("EUR", "")

    this.container.querySelector('.custom-solution-buy-button .product-price .compare-price').textContent =
      theme.Currency.formatMoney(totalComparePrice, priceFormat).replace("EUR", "")

    const customProductPrice = this.container.querySelector('.custom-solution-buy-button .product-price')
    const customSavingsEl = customProductPrice.querySelector('.total-savings')
    if (totalComparePrice > totalPrice) {
      customSavingsEl.textContent =
        '-' +
        theme.Currency.formatMoney(totalComparePrice - totalPrice, theme.moneyFormat)
      customProductPrice.classList.add('sale')
    } else {
      customSavingsEl.textContent = ''
      customProductPrice.classList.remove('sale')
    }


    if(hasBracket){
      document.querySelector('.progress-bar div').style.width = (num / 4) * 100.0 + '%'
    }else{
      document.querySelector('.progress-bar div').style.width = (num / 3) * 100.0 + '%'
    }
    const bundleList = this.container.querySelector('[data-tab-id="custom-solution"] .bundle-list--custom')
    const customItemsContainer = bundleList ? bundleList.querySelector('.bundle-list__items') : null
    const customAddonsContainer = bundleList ? bundleList.querySelector('.bundle-list__addons') : null
    const customThumbEl = bundleList ? bundleList.querySelector('.bundle-list__thumb') : null
    const customTitleEl = bundleList ? bundleList.querySelector('.bundle-list__title-text') : null
    const customPriceEl = bundleList ? bundleList.querySelector('.bundle-list__price') : null
    const customCompareEl = bundleList ? bundleList.querySelector('.bundle-list__compare') : null
    const customTitleSource = this.container.querySelector('.custom-solution-buy-button .buy-now__product-title span')
    const customTitleText = customTitleSource
      ? customTitleSource.textContent.trim()
      : this.formData.items[0]
        ? this.formData.items[0].title
        : ""
    const customMainImage = this.formData.items.find((formItem) => formItem.variantImg)
    let buyItems = ""

    if (customTitleEl) {
      customTitleEl.textContent = customTitleText
    }
    if (customThumbEl) {
      customThumbEl.innerHTML = customMainImage ? `<img src="${customMainImage.variantImg}" alt="${customTitleText}">` : ""
    }
    if (customPriceEl) {
      customPriceEl.textContent = theme.Currency.formatMoney(totalPrice, priceFormat).replace("EUR", "")
    }
    if (customCompareEl) {
      if (totalComparePrice > totalPrice) {
        customCompareEl.textContent = theme.Currency.formatMoney(totalComparePrice, priceFormat).replace("EUR", "")
        customCompareEl.classList.remove('is-hidden')
      } else {
        customCompareEl.textContent = ""
        customCompareEl.classList.add('is-hidden')
      }
    }
    if (customItemsContainer) {
      customItemsContainer.querySelectorAll(".bundle-list__item").forEach((item) => item.remove())
    }
    if (customAddonsContainer) {
      customAddonsContainer.querySelectorAll(".bundle-list__card--addon").forEach((item) => item.remove())
    }

    bundleList.querySelectorAll(".bundle-list__recommend-items .bundle-list__card").forEach(itemEle => {
      itemEle.classList.remove('hidden')
    }) 
    this.formData.items.forEach((item) => {
      const quantityText = item.showQuantity ? item.showQuantity : item.quantity
      if (item.group === 'addon') {
        if (customAddonsContainer) {
          const itemPrice = typeof item.price === 'number'
            ? theme.Currency.formatMoney(item.price, priceFormat).replace("EUR", "")
            : ""
          const itemCompare = typeof item.comparePrice === 'number' && item.comparePrice > item.price
            ? theme.Currency.formatMoney(item.comparePrice, priceFormat).replace("EUR", "")
            : ""
          const compareHtml = itemCompare ? `<span class="bundle-list__compare">${itemCompare}</span>` : ""
          const imageHtml = item.variantImg
            ? `<div class="bundle-list__thumb"><img src="${item.variantImg}" alt="${item.title}"></div>`
            : `<div class="bundle-list__thumb"></div>`
          const addonsRemove = this.dataset.addonsActionRemove || 'Remove'
          customAddonsContainer.insertAdjacentHTML(
            "beforeend",
            `<div class="bundle-list__card bundle-list__card--addon">
              ${imageHtml}
              <div class="bundle-list__addon-info">
                <div class="bundle-list__addon-head">
                  <p class="bundle-list__addon-title">${item.title}</p>
                  <span class="bundle-list__addon-action" data-variant-id="${item.id}">${addonsRemove}</span>
                </div>
                <div class="bundle-list__prices">
                  <span class="bundle-list__price">${itemPrice}</span>
                  ${compareHtml}
                </div>
                <div class="bundle-list__addon-qty">×${quantityText}</div>
              </div>
            </div>`
          )
        }

       

        bundleList.querySelectorAll(".bundle-list__recommend-items .bundle-list__card").forEach(itemEle => {
          if(itemEle.querySelector(`.bundle-list__addon-action[data-variant-id="${item.id}"]`)){
            itemEle.classList.add('hidden')
          }
        })
      } else if (customItemsContainer && item.list !== false) {
        customItemsContainer.insertAdjacentHTML(
          "beforeend",
          `<div class="bundle-list__item">
            <div class="bundle-list__item-title">${item.title}</div>
            <div class="bundle-list__item-qty">×${quantityText}</div>
          </div>`
        )
      }

      if(item.group === 'main'){
        if (!buyItems) {
          buyItems = `<span>${quantityText} × ${item.title}</span>`
        } else {
          buyItems = buyItems + `<span>${quantityText} × ${item.title}</span>`
        }
      }
    })

    document.querySelectorAll(".product_subtitle").forEach(item => {
      item.innerHTML = buyItems
    })

    this._setupAddonsViewMore(customAddonsContainer, 'custom-solution')

    this.container.querySelector('[data-tab-id="custom-solution"]').querySelector(".buy-now__content-items").innerHTML = bundleList.querySelector(".bundle-list__card--main").outerHTML + bundleList.querySelector(".bundle-list__addons").outerHTML


    // const klarnaEle = this.container.querySelector('.custom-solution-buy-button .product-klarna')

    // if (klarnaEle && klarnaEle.dataset.info) {
    //   klarnaEle.querySelector('.info').innerHTML = klarnaEle.dataset.info.replace(
    //     '${price}',
    //     theme.Currency.formatMoney(totalPrice / 3.0, priceFormat).replace("EUR", "")
    //   )

    //   const klarna = this.container.querySelector('.custom-solution-buy-button .product-klarna klarna-placement')
    //   if (klarna) {
    //     klarna.setAttribute('data-purchase-amount', totalPrice)
    //     if (window.Klarna && window.Klarna.OnsiteMessaging) {
    //       window.Klarna.OnsiteMessaging.refresh()
    //     }
    //   }
    // }
    const gocertifyEleCustom = this.container.querySelector('gocertify-placement');
    if (gocertifyEleCustom) {
      gocertifyEleCustom.setAttribute('data-purchase-amount', totalPrice);
    }

    const klarnaEle = document.querySelector(".PayPal_box_content_main klarna-placement");
    const paypalEle = document.querySelector(".PayPal_box_content_main [data-pp-message]");
    const bnpEle = document.querySelector(".PayPal_box_content_main [data-bnp-message]");
    const paymentEles = document.querySelectorAll("[data-payment-trigger]");

    if(klarnaEle){
      klarnaEle.setAttribute('data-purchase-amount',  totalPrice);
      if (window.Klarna && window.Klarna.OnsiteMessaging) {
        window.Klarna.OnsiteMessaging.refresh()
      }
    }
    window.reloadBnb?window.reloadBnb(totalPrice):''
    if(paypalEle){
      paypalEle.setAttribute('data-pp-amount',totalPrice / 100.0);
    }
    if(bnpEle){
      bnpEle.setAttribute('data-bnp-amount',totalPrice / 100.0);
    }
    if(paymentEles){
      paymentEles.forEach(paymentEle => {
        paymentEle.setAttribute('data-payment-amount',totalPrice / 100.0);
      })
    }
    if (typeof window.updatePdpIntroductionAmount === 'function') {
      window.updatePdpIntroductionAmount(totalPrice);
    }
    this.updateDiyWhatsInTheBox("#custom");
  }

  updateDiyWhatsInTheBox(selector) {
    let container = document.querySelector(".diy-whats-in-the-box");
    if(selector){
     container = document.querySelector(selector);
    }
    if(container){
        const diyItems = container.querySelectorAll(".dwitb-item[data-variant-ids]");
        const diyNotItems = container.querySelectorAll(".dwitb-item:not([data-variant-ids])");
    
        diyNotItems.forEach(item => {
          item.classList.add("variant-show");
        })
    
        container.querySelectorAll(".dwitb-item__box.show").forEach(item => item.classList.remove("show"));
        diyItems.forEach(item => {
          item.classList.remove("variant-show");
          this.formData.items.forEach(formItem => {
            if(item.dataset.variantIds.includes(formItem.id)){
              item.classList.add("variant-show");
              const quantityItems = item.querySelectorAll(".dwitb-item__box[data-variant-id]")
              quantityItems.forEach(item => {
                if(item.dataset.variantId.includes(formItem.id)){
                  item.dataset.quantity = formItem.showQuantity?formItem.showQuantity:formItem.quantity
                  item.classList.add("show")
                }
              })
            }
          })
        })
    
        const diyAllItems = container.querySelectorAll(".dwitb-item");    
    
        const is_expand = container.querySelector(".dwitb-item__footer.expand");
       let show_index = 0;
       diyAllItems.forEach(item => {
        if(item.classList.contains("variant-show")){
          show_index += 1;
    
          item.querySelectorAll(".dwitb-item__tag").forEach(tag => {
            if(tag.closest(".dwitb-item__box").dataset.quantity){
              let ratio = parseFloat(tag.dataset.ratio?tag.dataset.ratio:"1");
              tag.innerText = "×" + (parseFloat(tag.closest(".dwitb-item__box").dataset.quantity) * ratio)
            }
          })
          
          if(show_index == 1 || is_expand){
            item.classList.remove("hide")
          }
        }else{
          item.classList.add("hide")
        }
       })
    
    
       if(show_index > 1){
         container.querySelector(".dwitb-item__footer").classList.remove("hide")
       }else{
         container.querySelector(".dwitb-item__footer").classList.add("hide")
       }
    }
    
    // 初始化倒计时功能
    this.initCountdown()
  }

  disconnectedCallback() {
    // 清理倒计时定时器
    const countdownElements = document.querySelectorAll('[data-count-down]')
    countdownElements.forEach(element => {
      if (element.countdownInterval) {
        clearInterval(element.countdownInterval)
        element.countdownInterval = null
      }
    })
  }

  /** InsCoder WANG.J 2026-09-23 B + Toggle accessories by one or more selected main variant IDs **/
  _updateVariantAccessoryVisibility() {
    const currentVariantId = this.currentVariant ? String(this.currentVariant.id) : ''

    this.container.querySelectorAll('[data-related-variant-id]').forEach((item) => {
      const relatedVariantIds = (item.dataset.relatedVariantId || '')
        .split(',')
        .map((variantId) => variantId.trim())
        .filter(Boolean)
      const shouldShow = relatedVariantIds.length === 0 || relatedVariantIds.includes(currentVariantId)

      item.hidden = !shouldShow
      item.classList.toggle('variant-accessory--hidden', !shouldShow)

      if (shouldShow) return

      if (item.classList.contains('accessory-option')) {
        const checkbox = item.querySelector(':scope > input[type="checkbox"]')
        if (checkbox) checkbox.checked = false
        const quantityValue = item.querySelector('.quantity-value')
        if (quantityValue) quantityValue.textContent = '0'
      }

      if (item.classList.contains('cust-install__service')) {
        item.querySelectorAll('.install-checkbox_input').forEach((checkbox) => {
          checkbox.checked = false
        })
      }
    })
  }
  /** InsCoder WANG.J 2026-09-23 E + Toggle accessories by one or more selected main variant IDs **/

  updateCurrentVariant() {
    if(!this.container.querySelector('.variant-buttons .variant-button__item.open')){
      return;
    }
    const openBundle = this.container.querySelector('.variant-buttons .variant-button__item.open')
    if (!openBundle) {
      if (this.dataset.enablePreheat === 'true') {
        this.currentVariant = this.product.variants.find((item) => item.available) || this.product.variants[0]
        if (this.currentVariant) {
          this._updateImages()
        }
      }
      return
    }
    const variant_id = openBundle.dataset.variantId
    this.product.variants.forEach((item) => {
      if (item.id == variant_id) {
        this.currentVariant = item
        if(openBundle.dataset.customPrice){
          this.currentVariant.price = parseInt(openBundle.dataset.customPrice)
        }
        if(openBundle.dataset.customComparePrice){
          this.currentVariant.compare_at_price = parseInt(openBundle.dataset.customComparePrice)
        }
      }
    })

    var variant = this.currentVariant

    if (!variant) {
      this.productState.available = false
      this._toggleStreamBundlesPurchaseButtons()
      return
    }

    // const optionLabelIncluded = this.container.querySelector('.buy-now-container [data-tax-included]')
    // const optionLabelExcluded = this.container.querySelector('.buy-now-container [data-tax-excluded]')
    // if(variant.title.replace(/\s/g, '').includes("0%")){
    //   optionLabelIncluded.classList.add('hide')
    //   optionLabelExcluded.classList.remove('hide')
    // }else{
    //   optionLabelIncluded.classList.remove('hide')
    //   optionLabelExcluded.classList.add('hide')
    // }

    const buybutton = this.container.querySelector('.buy-now__button [data-variant-id]')

    // buybutton.dataset.variantId = variant.id

    this.productState.available = true
    this.productState.soldOut = !variant.available
    this.productState.onSale = variant.compare_at_price > variant.price
    this.productState.showUnitPrice = !!variant.unit_price

    this._updateVariantAccessoryVisibility()
    this._updateImages()
    this._updatePrice()
    this._toggleStreamBundlesPurchaseButtons()
  }

  _toggleStreamBundlesPurchaseButtons() {
    const streamTab = this.container.querySelector('[data-tab-id="stream-bundles"]')
    if (!streamTab) return

    const purchaseBox = streamTab.querySelector('.buy-now__button')
    if (!purchaseBox) return

    const atcButtons = purchaseBox.querySelectorAll('.custom-buy-button')
    const bisButton = purchaseBox.querySelector('.emarsys-bis-trigger')
    if (!bisButton) return

    const showAtc = !!(this.currentVariant && this.currentVariant.available)
    atcButtons.forEach((btn) => {
      btn.classList.toggle('hide', !showAtc)
    })
    if (bisButton) {
      bisButton.classList.toggle('hide', showAtc)
    }
  }

  _klarna() {
    // const klarnas = this.container.querySelectorAll('.product-klarna .info')
    // klarnas.forEach((klarna) => {
    //   klarna.addEventListener('click', (e) => {
    //     const klarnaEle = klarna.nextElementSibling
    //     if (klarnaEle && klarnaEle.shadowRoot) {
    //       klarnaEle.shadowRoot.querySelector('button').click()
    //     }
    //   })
    // })
    const paypalBox = document.querySelector('.cust-powerstream-v6 .PayPal_box');
    const paypal_method_btns = document.querySelectorAll('.cust-powerstream-v6 .paypal_method .paypal_text, a.payments');
    const closeBtn = paypalBox.querySelector('.close_btn');
    // paypal_method_btns.forEach(paypal_method_btn => {
    //   paypal_method_btn.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     if (paypalBox) {
    //       paypalBox.classList.add('active');
    //     }
    //   });
    // })
    closeBtn.addEventListener('click', () => {
      if (paypalBox) {
        paypalBox.classList.remove('active');
      }
    });
  }

  /**
   * 同步 URL 为 ?variant=xxx（保留其它 query 与 hash），便于分享/定位
   */
  _setVariantParam(variantId) {
    if (!variantId) return
    const params = new URLSearchParams(window.location.search)
    if (params.get('variant') === String(variantId)) return
    params.set('variant', String(variantId))
    const search = params.toString()
    const url = window.location.pathname + (search ? '?' + search : '') + window.location.hash
    window.history.replaceState(null, '', url)
  }

  _initVariantButtons() {
    const variantButtons = this.container.querySelectorAll('.variant-buttons .variant-button__item')
    variantButtons.forEach((variantBtn) => {
      variantBtn.addEventListener('click', (e) => {
        // Let notice links navigate without triggering the variant card's redirect.
        const target = e.target?.nodeType === 1 ? e.target : e.target?.parentElement
        if (target?.closest('.variant-notice a')) return
        
        this.container.querySelector('.variant-buttons .variant-button__item.open').classList.remove('open')
        variantBtn.classList.add('open')

        this.container.querySelector('#save-per-year').innerHTML = variantBtn.dataset.savePerYear
        this.container.querySelector('#capacity').innerHTML = variantBtn.dataset.capacity
        this.container.querySelector('#electricity-generated').innerHTML = variantBtn.dataset.electricityGenerated
        if(variantBtn.dataset.giftTitle){
          
          let html = `<div class="title">${variantBtn.dataset.giftTitle}</div><div class="addon-items"></div>`;
          this.container.querySelector(".product-addonimage").innerHTML = html;
          if(variantBtn.dataset.addonTitle1 || variantBtn.dataset.addonImage1){
            this.container.querySelector(".product-addonimage .addon-items").insertAdjacentHTML('beforeend',`<div class="addon-item"><img src="${variantBtn.dataset.addonImage1}">${ variantBtn.dataset.addonTitle1 ? `<div><span class="addon-title">${variantBtn.dataset.addonTitle1}</span><span class="addon-price">${variantBtn.dataset.addonPrice1}</span></div>`: '' } </div>`)
          }
          if(variantBtn.dataset.addonTitle2 || variantBtn.dataset.addonImage2){
            this.container.querySelector(".product-addonimage .addon-items").insertAdjacentHTML('beforeend',`<div class="addon-item"><img src="${variantBtn.dataset.addonImage2}">${ variantBtn.dataset.addonTitle2 ? `<div><span class="addon-title">${variantBtn.dataset.addonTitle2}</span><span class="addon-price">${variantBtn.dataset.addonPrice2}</span></div>`:'' }</div>`)
          }
        }else{
          this.container.querySelector(".product-addonimage").innerHTML = ""
        }

        this.updateCurrentVariant()
        this._setVariantParam(variantBtn.dataset.variantId)
      })
    })
  }

  // update recommend
  _updatePrice() {
    this.formData.items = []
    const badges_container = this.container.querySelector('.recommend-product-gallery .embed-item-container');
    badges_container.querySelectorAll(".badge-item").forEach(item => item.remove());
    var priceFormat = theme.priceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat

    let totalPrice = 0
    let totalComparePrice = 0
    
    let accessoriesPrice = 0
    let accessoriesComparePrice = 0
    const accessoriesCheckbox = this.container.querySelectorAll('[data-tab-id="stream-bundles"] .accessory-options .accessory-option>input[type="checkbox"]:checked')
    accessoriesCheckbox.forEach((checkbox) => {
      const accessoriesOption = checkbox.closest('.accessory-option')
      const quantity = parseInt(accessoriesOption.querySelector('.quantity-value').textContent)
      accessoriesPrice += parseFloat(accessoriesOption.dataset.price) * quantity
      accessoriesComparePrice += parseFloat(accessoriesOption.dataset.comparePrice) * quantity

      const installService = accessoriesOption.nextElementSibling;
      if(installService && installService.classList.contains("cust-install__service")){
        const checkboxItemInput = installService.querySelector(".install-checkbox_input:checked");
        if(checkboxItemInput){
          const checkboxItem = checkboxItemInput.closest(".install-block");
          const quantityCheckItem = parseInt(checkboxItem.querySelector('.quantity-value').textContent);
          accessoriesPrice += parseFloat(checkboxItem.dataset.price) * quantity
          accessoriesComparePrice += parseFloat(checkboxItem.dataset.comparePrice) * quantity

          const variantImg = checkboxItem.querySelector(".variant-img")?checkboxItem.querySelector(".variant-img").src: checkboxItem.dataset.embedImage? checkboxItem.dataset.embedImage : ""
          this.formData.items.push({
            id: checkboxItem.dataset.variantId,
            title: checkboxItem.querySelector('.install-content-title').innerText,
            quantity: quantityCheckItem,
            variantImg: variantImg,
            price: parseFloat(checkboxItem.dataset.price),
            comparePrice: parseFloat(checkboxItem.dataset.comparePrice),
            group: 'addon'
          })
        }
      }
      
      const variantImg = accessoriesOption.querySelector(".variant-img")?accessoriesOption.querySelector(".variant-img").src: accessoriesOption.dataset.embedImage? accessoriesOption.dataset.embedImage : ""
      this.formData.items.push({
        id: accessoriesOption.dataset.variantId,
        title: accessoriesOption.querySelector('.accessory-name').innerText,
        quantity: quantity,
        variantImg: variantImg,
        price: parseFloat(accessoriesOption.dataset.price),
        comparePrice: parseFloat(accessoriesOption.dataset.comparePrice),
        group: 'addon'
      })


      const accessory_badges = badges_container.querySelectorAll(".accessory-badge");
      if(accessory_badges.length){
        accessory_badges[accessory_badges.length - 1].insertAdjacentHTML("afterend",`<span class="accessory-badge badge-item accessory-order-${accessoriesOption.dataset.accessoryBadge}">×${quantity}</span>`)
      }else{
        badges_container.insertAdjacentHTML("afterbegin",`<span class="accessory-badge badge-item accessory-order-${accessoriesOption.dataset.accessoryBadge}">×${quantity}</span>`)
      }
     
    })

    if(this.container.querySelector('#accessories-price-v2')){    
      this.container.querySelector('#accessories-price-v2').textContent = theme.Currency.formatMoney(
        accessoriesPrice,
        priceFormat
      ).replace("EUR", "")
    }
    
    totalPrice += accessoriesPrice
    totalComparePrice += accessoriesComparePrice
    
    var variant = this.currentVariant
    totalPrice += variant.price
    totalComparePrice += variant.compare_at_price

    var current_variant_id = variant.id + ""

    const openVariantButton = this.container.querySelector('.variant-buttons .variant-button__item.open')
    const title = openVariantButton ? openVariantButton.querySelector('.title').textContent : ""
    const variantImg = openVariantButton
      ? openVariantButton.querySelector(".variant-img")
        ? openVariantButton.querySelector(".variant-img").src
        : ""
      : ""
    const streamBundleList = this.container.querySelector('[data-tab-id="stream-bundles"] .bundle-list--stream')
    const streamItemsContainer = streamBundleList ? streamBundleList.querySelector('.bundle-list__items') : null
    const streamAddonsContainer = streamBundleList ? streamBundleList.querySelector('.bundle-list__addons') : null
    const streamTitleEl = streamBundleList ? streamBundleList.querySelector('.bundle-list__title-text') : null
    const streamThumbEl = streamBundleList ? streamBundleList.querySelector('.bundle-list__thumb') : null
    const streamPriceEl = streamBundleList ? streamBundleList.querySelector('.bundle-list__price') : null
    const streamCompareEl = streamBundleList ? streamBundleList.querySelector('.bundle-list__compare') : null

    if (streamTitleEl) {
      streamTitleEl.textContent = title
    }
    if (streamThumbEl) {
      streamThumbEl.innerHTML = variantImg ? `<img src="${variantImg}" alt="${title}">` : ""
    }
    if (streamPriceEl) {
      streamPriceEl.textContent = theme.Currency.formatMoney(variant.price, priceFormat).replace("EUR", "")
    }
    if (streamCompareEl) {
      if (variant.compare_at_price > variant.price) {
        streamCompareEl.textContent = theme.Currency.formatMoney(variant.compare_at_price, priceFormat).replace("EUR", "")
        streamCompareEl.classList.remove('is-hidden')
      } else {
        streamCompareEl.textContent = ""
        streamCompareEl.classList.add('is-hidden')
      }
    }
    if (streamItemsContainer) {
      streamItemsContainer.querySelectorAll(".bundle-list__item").forEach((item) => item.remove())
    }
    if (streamAddonsContainer) {
      streamAddonsContainer.querySelectorAll(".bundle-list__card--addon").forEach((item) => item.remove())
    }

    this.formData.items.push({
      id: current_variant_id,
      title: title,
      quantity: 1,
      variantImg: variantImg,
      group: 'main',
      list: false
    })

    // this.container.querySelector('.stream-bundles-buy-button .product-klarna').setAttribute('data-purchase-amount', totalPrice)
    // if (window.Klarna && window.Klarna.OnsiteMessaging) {
    //   window.Klarna.OnsiteMessaging.refresh()
    // }

    const klarnaEle = document.querySelector(".PayPal_box_content_main klarna-placement");
    const paypalEle = document.querySelector(".PayPal_box_content_main [data-pp-message]");
    const bnpEle = document.querySelector(".PayPal_box_content_main [data-bnp-message]");
    const paymentEles = document.querySelectorAll("[data-payment-trigger]");

    if(klarnaEle){
      klarnaEle.setAttribute('data-purchase-amount', totalPrice);
      if (window.Klarna && window.Klarna.OnsiteMessaging) {
        window.Klarna.OnsiteMessaging.refresh()
      }
    }
    window.reloadBnb?window.reloadBnb(totalPrice):''
    if(paypalEle){
      paypalEle.setAttribute('data-pp-amount', totalPrice / 100.0);
    }
    if(bnpEle){
      bnpEle.setAttribute('data-bnp-amount',totalPrice / 100.0);
    }
    if(paymentEles){
      paymentEles.forEach(paymentEle => {
        paymentEle.setAttribute('data-payment-amount',totalPrice / 100.0);
      })
    }
    if (typeof window.updatePdpIntroductionAmount === 'function') {
      window.updatePdpIntroductionAmount(totalPrice);
    }
    
    const streamProductPrice = this.container.querySelector('.stream-bundles-buy-button .product-price')
    if (streamProductPrice) {
      streamProductPrice.querySelector('.price').textContent =
        theme.Currency.formatMoney(totalPrice, priceFormat).replace("EUR", "")
      streamProductPrice.querySelector('.compare-price').textContent =
        theme.Currency.formatMoney(totalComparePrice, priceFormat).replace("EUR", "")
      const streamSavingsEl = streamProductPrice.querySelector('.total-savings')
      if (totalComparePrice > totalPrice) {
        streamSavingsEl.textContent =
          '-' +
          theme.Currency.formatMoney(totalComparePrice - totalPrice, theme.moneyFormat)
        streamProductPrice.classList.add('sale')
      } else {
        streamSavingsEl.textContent = ''
        streamProductPrice.classList.remove('sale')
      }
    }

    // const klarnaEle = this.container.querySelector('.stream-bundles-buy-button .product-klarna')

    // if (klarnaEle && klarnaEle.dataset.info) {
    //   klarnaEle.querySelector('.info').innerHTML = klarnaEle.dataset.info.replace(
    //     '${price}',
    //     theme.Currency.formatMoney(current_price / 3.0, comparePriceFormat).replace("EUR", "")
    //   )
    // 
    const gocertifyEleCustom = this.container.querySelector('gocertify-placement');
    if (gocertifyEleCustom) {
      gocertifyEleCustom.setAttribute('data-purchase-amount', totalPrice);
    }

    streamBundleList.querySelectorAll(".bundle-list__recommend-items .bundle-list__card").forEach(itemEle => {
      itemEle.classList.remove('hidden')
    })

    let buyItems = ""
    this.formData.items.forEach((item) => {
      const quantityText = item.showQuantity ? item.showQuantity : item.quantity
      if (item.group === 'addon') {
        if (streamAddonsContainer) {
          const itemPrice = typeof item.price === 'number'
            ? theme.Currency.formatMoney(item.price, priceFormat).replace("EUR", "")
            : ""
          const itemCompare = typeof item.comparePrice === 'number' && item.comparePrice > item.price
            ? theme.Currency.formatMoney(item.comparePrice, priceFormat).replace("EUR", "")
            : ""
          const compareHtml = itemCompare ? `<span class="bundle-list__compare">${itemCompare}</span>` : ""
          const imageHtml = item.variantImg
            ? `<div class="bundle-list__thumb"><img src="${item.variantImg}" alt="${item.title}"></div>`
            : `<div class="bundle-list__thumb"></div>`
          const addonsRemove = this.dataset.addonsActionRemove || 'Remove'
          streamAddonsContainer.insertAdjacentHTML(
            "beforeend",
            `<div class="bundle-list__card bundle-list__card--addon">
              ${imageHtml}
              <div class="bundle-list__addon-info">
                <div class="bundle-list__addon-head">
                  <p class="bundle-list__addon-title">${item.title}</p>
                  <span class="bundle-list__addon-action" data-variant-id="${item.id}">${addonsRemove}</span>
                </div>
                <div class="bundle-list__prices">
                  <span class="bundle-list__price">${itemPrice}</span>
                  ${compareHtml}
                </div>
                <div class="bundle-list__addon-qty">×${quantityText}</div>
              </div>
            </div>`
          )
        }

        streamBundleList.querySelectorAll(".bundle-list__recommend-items .bundle-list__card").forEach(itemEle => {
          if(itemEle.querySelector(`.bundle-list__addon-action[data-variant-id="${item.id}"]`)){
            itemEle.classList.add('hidden')
          }
        })
      } else if (streamItemsContainer && item.list !== false) {
        streamItemsContainer.insertAdjacentHTML(
          "beforeend",
          `<div class="bundle-list__item">
            <div class="bundle-list__item-title">${item.title}</div>
            <div class="bundle-list__item-qty">×${quantityText}</div>
          </div>`
        )
      }
      if(item.group === 'main'){
        if (!buyItems) {
          buyItems = `<span>${quantityText} × ${item.title}</span>`
        } else {
          buyItems = buyItems + `<span>${quantityText} × ${item.title}</span>`
        }
      }
    })

    

    const bundles = openVariantButton.querySelectorAll(".bundles-content span")
    bundles.forEach(bundle => {
        streamItemsContainer.insertAdjacentHTML(
        "beforeend",
        `<div class="bundle-list__item">
          <div class="bundle-list__item-title">${bundle.innerHTML}</div>
          <div class="bundle-list__item-qty">×${bundle.dataset.quantity}</div>
        </div>`
      )
    })

    document.querySelectorAll(".product_subtitle").forEach(item => {
      item.innerHTML = buyItems
    })

    this._setupAddonsViewMore(streamAddonsContainer, 'stream-bundles')

    this.container.querySelector('[data-tab-id="stream-bundles"]').querySelector(".buy-now__content-items").innerHTML = streamBundleList.querySelector(".bundle-list__card--main").outerHTML + streamBundleList.querySelector(".bundle-list__addons").outerHTML

    this.updateDiyWhatsInTheBox("#bundles");
  }

  _updateImages() {
    var variant = this.currentVariant

    var slider = this.container.querySelector('[data-product-main-slider]')
    var featuredMediaIndex = 0
    var variantMedia = variant.featured_media


    
    if (variantMedia) {
      var variantMediaId = variant.featured_media.id

      this.flickityInstance?.destroy()
      // hide other images
      slider.querySelectorAll('.product-single__media__slide.hidden').forEach(item => {
        item.classList.remove('hidden');
      })
      this.product.variants.forEach(item => {
        if (item.featured_media && item.featured_media.id != variantMediaId) {
          slider.querySelectorAll('.product-single__media__slide[data-media-id="'+item.featured_media.id+'"]').forEach(item => {
            item.classList.add('hidden') 
          })
        }
      })
      this.flickityInstance = new Flickity(slider, JSON.parse(slider.getAttribute('data-flickity-config')))
      this.flickityInstance.element.classList.add('rendered')
      this._bindGalleryArrows()

      document.querySelector('.product__media__pagination .total').innerHTML = this.flickityInstance.slides.length;
      this.flickityInstance.on('select', (index) => {

        document.querySelector('.product__media__pagination .current').innerHTML = parseInt(index) + parseInt(1);
        if(index == 0){
          document.querySelector('.product__media__pagination .current').classList.add('first');
        }else{
          document.querySelector('.product__media__pagination .current').classList.remove('first');
        }
        var flickity_slider = this.flickityInstance.element

        var selectedSlide = this.flickityInstance.selectedElement

        document.querySelectorAll('.product-single__thumbnails-block').forEach(function (elem) {
          elem.classList.remove('selected')
        })

        const selectedThumb = document.querySelector(
          '.product-single__thumbnails-block[data-media-id="' + selectedSlide.getAttribute('data-media-id') + '"]'
        )
        if (selectedThumb) {
          selectedThumb.classList.add('selected')
        } else {
          console.error('Element not found for data-thumb-index:', selectedSlide.getAttribute('data-media-index'))
        }
      })

      const thumbnailsWrapper = this.container.querySelector('.thumbnails-wrapper')
      thumbnailsWrapper.querySelectorAll('.product-single__thumbnails-block.hidden').forEach(item => {
          item.classList.remove('hidden')
      })
      this.product.variants.forEach(item => {
        if (item.featured_media && item.featured_media.id != variantMediaId) {
          thumbnailsWrapper.querySelectorAll('.product-single__thumbnails-block[data-media-id="'+item.featured_media.id+'"]').forEach(item => {
            item.classList.add('hidden')
          })
        }
      })

      // 
      const featuredThumb = document.querySelector(
        '.product-single__thumbnails-block[data-media-id="' + variantMediaId + '"]'
      )
      const swiperWrapper = thumbnailsWrapper.querySelector('.swiper-wrapper');
      if (swiperWrapper && featuredThumb) {
        swiperWrapper.insertBefore(featuredThumb, swiperWrapper.firstChild);
      }
      thumbnailsWrapper.swiper?thumbnailsWrapper.swiper.update():''
      
      this.flickityInstance?.select(0)
      // featuredThumb.click();
    }

  }
  _initPreheatGallery() {
    const single_group = document.querySelector('.product-single__media-group')
    if (single_group) single_group.classList.remove('single-media')

    const embedImage = this.container.querySelector('.product-single__media.has-embed-image')
    const mainGallery = this.container.querySelector('.product-single__media-recommend') || this.container.querySelector('.product-single__media.product-single__media-recommend')
    const thumbnails = this.container.querySelector('.thumbnails-slider')
    const product__media__arrows = this.container.querySelector('.product_tab__media__arrows')

    if (mainGallery) {
      mainGallery.classList.add('active')
      mainGallery.style.display = 'block'
    }
    if (product__media__arrows) product__media__arrows.style.display = 'block'
    if (thumbnails) thumbnails.style.display = 'flex'
    if (embedImage) {
      embedImage.classList.remove('active')
      embedImage.style.display = 'none'
    }
    this._resetMediaTabsToFirst(mainGallery)
    this._resizeProductCarouselWhenVisible()
  }

  _bindGalleryArrows() {
    const prevBtn = this.container.querySelector('.product_tab__media__arrows .btn-previous')
    const nextBtn = this.container.querySelector('.product_tab__media__arrows .btn-next')
    if (!this.flickityInstance || !prevBtn || !nextBtn) return
    prevBtn.onclick = () => this.flickityInstance.previous()
    nextBtn.onclick = () => this.flickityInstance.next()
  }

  _initTabButtons() {
    const tabButtons = this.container.querySelector('.product-tab-buttons')
    if (!tabButtons) {
      return
    }
    tabButtons.addEventListener('click', (e) => {
      const btn = e.target.closest('.button')
      if (!btn) return

      e.stopPropagation()
      this.container.querySelector('.product-tab-buttons .button.active').classList.remove('active')
      btn.classList.add('active')
      if( btn.classList.contains('show-variant-items') ){
        return;
      }
      const breadcrumbsList = document.querySelector('.breadcrumbs__list')
      const single_group = document.querySelector('.product-single__media-group')

      this._initProductParams()
      if (btn.id === 'help-me-choose') {
        single_group.classList.remove('single-media')
        this._resetSteps()
        this.savePerYear.innerHTML = this.savePerYear.innerHTML.replace(/(?:\d+[\s,]*)+/g, '0 ')
        this.capacity.innerHTML = this.capacity.innerHTML.replace(/(?:\d+[\s,]*)+/g, '0 ')
        this.container.querySelector('.product-params').classList.remove('hidden')

        const embedImage = this.container.querySelector('.product-single__media.has-embed-image')
        const mainGallery = this.container.querySelector('.product-single__media-recommend') || this.container.querySelector('.product-single__media.product-single__media-recommend')
        const bundleGallery = this.container.querySelector('.bundle-gallery')
        const thumbnails = this.container.querySelector('.thumbnails-slider')
        const product__media__arrows = this.container.querySelector('.product_tab__media__arrows')
        if (mainGallery) mainGallery.style.display = 'block'
        if (product__media__arrows) product__media__arrows.style.display = 'block'
        if (thumbnails) thumbnails.style.display = 'flex'
        if (embedImage) embedImage.style.display = 'none'
        if (bundleGallery) bundleGallery.style.display = 'none'
        this._resetMediaTabsToFirst(mainGallery)
        this._resizeProductCarouselWhenVisible()
      } else if (btn.id === 'custom-solution') {
        single_group.classList.add('single-media')
        // this.container.querySelector('.product-params').classList.add('hidden')
        const embedImage = this.container.querySelector('.product-single__media.has-embed-image')
        const mainGallery = this.container.querySelector('.product-single__media-recommend') || this.container.querySelector('.product-single__media.product-single__media-recommend')
        const bundleGallery = this.container.querySelector('.bundle-gallery')
        const thumbnails = this.container.querySelector('.thumbnails-slider')
        const product__media__arrows = this.container.querySelector('.product_tab__media__arrows')
        if (embedImage) {
          embedImage.style.display = 'flex'
          embedImage.classList.add('active')
        }
        if (mainGallery){
          mainGallery.classList.remove('active')
          mainGallery.style.display = 'none'
        }
        if (bundleGallery) {
          bundleGallery.style.display = 'none'
          bundleGallery.classList.remove('active')
        }
        if (thumbnails) thumbnails.style.display = 'none'
        if (product__media__arrows) product__media__arrows.style.display = 'none'
        this._resetMediaTabsToFirst(embedImage)
      } else if (btn.id === 'stream-bundles') {
        single_group.classList.remove('single-media')
        this.container.querySelector('.product-params').classList.remove('hidden')

        const openBtn = this.container.querySelector('.variant-buttons .variant-button__item.open')
        if (openBtn) {
          this.container.querySelector('#save-per-year').innerHTML = openBtn.dataset.savePerYear
          this.container.querySelector('#capacity').innerHTML = openBtn.dataset.capacity
          this.container.querySelector('#electricity-generated').innerHTML = openBtn.dataset.electricityGenerated
        }
        const embedImage = this.container.querySelector('.product-single__media.has-embed-image')
        const mainGallery = this.container.querySelector('.product-single__media-recommend') || this.container.querySelector('.product-single__media.product-single__media-recommend')
        const bundleGallery = this.container.querySelector('.bundle-gallery')
        const thumbnails = this.container.querySelector('.thumbnails-slider')
        const product__media__arrows = this.container.querySelector('.product_tab__media__arrows')
        if (mainGallery){
          mainGallery.classList.add('active')
          mainGallery.style.display = 'block'
        }
        if (product__media__arrows) product__media__arrows.style.display = 'block'
        if (thumbnails) thumbnails.style.display = 'flex'
        if (embedImage){
           embedImage.classList.remove('active')
           embedImage.style.display = 'none'
        }
        if (bundleGallery)  bundleGallery.style.display = 'none'
        this._resetMediaTabsToFirst(mainGallery)
        this._resizeProductCarouselWhenVisible()
      }

      const guessItems = document.querySelector("[data-tab-id='"+btn.id+"'] .guess-items");
      if(guessItems){
        guessItems.style.setProperty("--min-height",  guessItems.querySelectorAll(".accessory-option")[0].offsetHeight + "px");
      }
    })
  }
  _resetSteps() {
    // Reset to first step when switching tabs
    this.currentStep = 1

    // Reset chooseForm to initial values

    // "monthElectricPriceBefore": 100,
    // "avgElectricPrice": 4,
    this.chooseForm = {
      longitude: '',
      latitude: '',
      country: '',
      address: '',
      website: 'de',
      familyStructure: 1,
      daytimeElectrPercentage: 50,
      unit: '$',
      bizType: 0,
      electricityPricePercentage: '35',
      solarPanelsPlace: [1]
    }

    // Reset steps UI
    const steps = this.container.querySelectorAll('.step')
    steps.forEach((step) => {
      if (step.dataset.step === '1') {
        step.classList.add('active', 'current')
      } else {
        step.classList.remove('active', 'current')
      }
    })

    // Hide all step contents and show only step 1
    const stepContents = this.container.querySelectorAll('.step-content > div')
    stepContents.forEach((content) => {
      if (content.classList.contains('step-1')) {
        content.style.display = 'block'
      } else {
        content.style.display = 'none'
      }
    })

    // Reset step 3 status box
    const statusBox = this.container.querySelector('.step-3-status')
    if (statusBox) {
      statusBox.style.display = 'none' // Clear status box content
    }

    // Reset form content to initial values
    this._initFormContent()
  }

  _updateRecommendImages(){
    const mainGallery = this.container.querySelector('.recommend-product-gallery')
    mainGallery.querySelectorAll(".embed-image").forEach(item => item.remove())
    const embedImageContainer = this.container.querySelector('.recommend-product-gallery .embed-item-container')
    this.container.querySelectorAll('[data-tab-id="stream-bundles"] .embed-item').forEach((item) => {
      // Find checkbox with max value
      const checkboxInputs = item.querySelectorAll('input[type="checkbox"]:checked')
      let maxCheckboxValue = -Infinity
      let maxCheckbox = null

      if (checkboxInputs.length > 1) {
        checkboxInputs.forEach((checkbox) => {
          const checkboxValue = parseFloat(checkbox.value)
          if (!isNaN(checkboxValue) && checkboxValue > maxCheckboxValue) {
            maxCheckboxValue = checkboxValue
            maxCheckbox = checkbox
          }
        })
        this._addEmbedImage(maxCheckbox.closest('[data-embed-image]'), embedImageContainer)
      } else if (checkboxInputs.length == 1) {
        this._addEmbedImage(checkboxInputs[0].closest('[data-embed-image]'), embedImageContainer)
      }
    }) 
  }
  _initProductImages() {
    const mainGallery = this.container.querySelector('.product-single__media .basic-images')
    mainGallery.querySelectorAll(".embed-image").forEach(item => item.remove())
    
    const basicImages = this.container.querySelector('.product-single__media .basic-images')
    this.container.querySelectorAll('[data-tab-id="custom-solution"] .embed-item').forEach((item) => {
      // Find checkbox with max value
      const checkboxInputs = item.querySelectorAll('input[type="checkbox"]:checked')
      let maxCheckboxValue = -Infinity
      let maxCheckbox = null

      if (checkboxInputs.length > 1) {
        checkboxInputs.forEach((checkbox) => {
          const checkboxValue = parseFloat(checkbox.value)
          if (!isNaN(checkboxValue) && checkboxValue > maxCheckboxValue) {
            maxCheckboxValue = checkboxValue
            maxCheckbox = checkbox
          }
        })
        this._addEmbedImage(maxCheckbox.closest('[data-embed-image]'), basicImages)
      } else if (checkboxInputs.length == 1) {
        this._addEmbedImage(checkboxInputs[0].closest('[data-embed-image]'), basicImages)
      }

      // Check for radio inputs with value > 0
      const radioInputs = item.querySelectorAll('input[type="radio"]:checked')
      radioInputs.forEach((radio) => {
        const radioValue = parseFloat(radio.value)
        if (!isNaN(radioValue) && radioValue > 0) {
          this._addEmbedImage(item, basicImages)
        }
      })


      if(item.classList.contains("active")){
        this._addEmbedImage(item, basicImages) 
      }


      if(item.classList.contains("bracket-item") && item.dataset.detailImage){
        this.container.querySelector('.product-single__media .bracket-details').innerHTML= `<img src="${item.dataset.detailImage}" alt="" class="embed-image">` 
      }
    })
  }

  _addEmbedImage(item, element) {
    if(item.dataset.embedImage){
      const embedImage = item.dataset.embedImage
      const zIndex = item.dataset.zIndex?item.dataset.zIndex: 1
      if (embedImage) {
        if(item.classList.contains("bracket-item")){
          element.insertAdjacentHTML(
            'beforeend',
            `<img src="${embedImage}" alt="" class="bracket-item embed-image" style="z-index: ${item.dataset.zIndex};">`
          ) 
        }else if(item.classList.contains("accessory-option")){
          element.insertAdjacentHTML(
            'beforeend',
            `<img src="${embedImage}" alt="" class="accessory-item embed-image" style="z-index: ${item.dataset.zIndex};">`
          ) 
        }else {
          element.insertAdjacentHTML(
            'beforeend',
            `<img src="${embedImage}" alt="" class="embed-image" style="z-index: ${item.dataset.zIndex};">`
          )
        }
      }
    }
  }

  _bindPhotoSwipeForElements(elements) {
    if (!elements || !elements.length) return

    elements.forEach(function (item, index) {
      item.addEventListener('click', function (e) {
        e.preventDefault()

        var pswpElement = document.querySelectorAll('.pswp')[0]

        var items = []
        var thumbnails = ''
        elements.forEach(function (imageEl, idx) {
          var imageObj = {
            src: imageEl.getAttribute('data-image-url'),
            w: +imageEl.getAttribute('data-image-width'),
            h: +imageEl.getAttribute('data-image-height')
          }
          items.push(imageObj)
          thumbnails +=
            '<div class="product_thumbnail"><img src="' + imageEl.getAttribute('data-image-url') + '" /></div>'
        })

        var options = {
          index: index,
          zoomEl: false,
          shareEl: false,
          fullscreenEl: false,
          counterEl: false,
          closeOnScroll: false,
          closeOnVerticalDrag: false
        }

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
        gallery.init()

        gallery.listen('imageLoadComplete', function() {
          setTimeout(() => {
          document.querySelectorAll(".pswp__zoom-wrap img.pswp__img:not(.uinited)").forEach(img => {
            let startDistance = 0;
            let scale = 1;
            img.classList.add("uinited");
            img.addEventListener("touchmove", function (e) {
              if (e.touches.length === 2) {
                e.preventDefault();

                const dx = e.touches[0].pageX - e.touches[1].pageX;
                const dy = e.touches[0].pageY - e.touches[1].pageY;
                const distance = Math.sqrt(dx * dx + dy * dy);

                if (!startDistance) startDistance = distance;

                scale = distance / startDistance;
                img.style.transform = `translateX(-50%) scale(${scale})`;
              }
            });
          });
          }, 500)
        });
        
        gallery.listen('afterChange', function (idx) {
          document.querySelector('.photoSwipe_innerthumbs .product_thumbnail.selected').classList.remove('selected')
          document
            .querySelectorAll('.photoSwipe_innerthumbs .product_thumbnail')
            [gallery.getCurrentIndex()].classList.add('selected')

          document.querySelectorAll(".pswp__zoom-wrap .pswp__img").forEach(img => {
            img.style.transform = "translateX(-50%)";
          })
        })

        if (thumbnails != '') {
          document.querySelector('div.photoSwipe_innerthumbs').innerHTML = thumbnails
          document
            .querySelectorAll('div.photoSwipe_innerthumbs .product_thumbnail')
            [gallery.getCurrentIndex()].classList.add('selected')

          document
            .querySelectorAll('div.photoSwipe_innerthumbs .product_thumbnail')
            .forEach(function (thumb, idx) {
              thumb.onclick = function () {
                document
                  .querySelector('div.photoSwipe_innerthumbs .product_thumbnail.selected')
                  .classList.remove('selected')
                thumb.classList.add('selected')
                gallery.goTo(idx)
              }
            })
          document.querySelector('.pswp__button--close').addEventListener('click', function (e) {
            gallery.destroy()
          })
        }
      })
    })
  }

  _initGallery(startIndex) {
    var main_slider = this.container.querySelector('.product-single__media__carousel')
    var thumbnails_grid = this.container.querySelector('.thumbnails-slider')
    var product_image__zoom = this.container.querySelector('.product_image__zoom')
    if (!main_slider) return

    var main_slider_options = JSON.parse(main_slider.getAttribute('data-flickity-config'))
    if (main_slider) {
      if (startIndex) {
        main_slider_options.initialIndex = startIndex
      }

      this.flickityInstance = new Flickity(main_slider, main_slider_options)
      this.flickityInstance.element.classList.add('rendered')
      this._bindGalleryArrows()
      this.flickityInstance.on('select', (index) => {

        document.querySelector('.product__media__pagination .current').innerHTML = parseInt(index) + parseInt(1);
        if(index == 0){
          document.querySelector('.product__media__pagination .current').classList.add('first');
        }else{
          document.querySelector('.product__media__pagination .current').classList.remove('first');
        }
        var flickity_slider = this.flickityInstance.element

        var selectedSlide = this.flickityInstance.selectedElement

        document.querySelectorAll('.product-single__thumbnails-block').forEach(function (elem) {
          elem.classList.remove('selected')
        })

        const selectedThumb = document.querySelector(
          '.product-single__thumbnails-block[data-media-id="' + selectedSlide.getAttribute('data-media-id') + '"]'
        )
        if (selectedThumb) {
          selectedThumb.classList.add('selected')
        } else {
          console.error('Element not found for data-thumb-index:', selectedSlide.getAttribute('data-media-index'))
        }
      })
    }

    if (product_image__zoom) {
      var imagesArr = main_slider.querySelectorAll('.image_type')
      this._bindPhotoSwipeForElements(imagesArr)
    }

    var sellingPointsCarousels = this.container.querySelectorAll('.selling-points__carousel')
    if (sellingPointsCarousels && sellingPointsCarousels.length) {
      sellingPointsCarousels.forEach((carousel) => {
        var slides = carousel.querySelectorAll('.selling-points__slide')
        this._bindPhotoSwipeForElements(slides)
      })
    }

    if (thumbnails_grid) {
        new Swiper(thumbnails_grid, {
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
        });

      
      thumbnails_grid.addEventListener('click', (e) => {
        const thumb = e.target.closest('.product-single__thumbnails-block:not(.hidden)');
        if (!thumb || !thumbnails_grid.contains(thumb)) return;

        e.preventDefault();

        const thumbnail_images = Array.from(
          thumbnails_grid.querySelectorAll('.product-single__thumbnails-block:not(.hidden)')
        );

        const index = thumbnail_images.indexOf(thumb);

        const current = thumbnails_grid.querySelector('.product-single__thumbnails-block.selected');
        current?.classList.remove('selected');

        thumb.classList.add('selected');

        this.flickityInstance.select(index);

        document.dispatchEvent(
          new CustomEvent('imageChange', {
            detail: {},
            bubbles: true,
            cancelable: true
          })
        );
      });
    }
  }

  _initGoogleMaps() {
    // 优先用默认坐标初始化地图
    this.currentLocation = { lat: 52.52, lng: 13.405 }
    this._initializeMap()

    // 再尝试定位，定位成功后 setCenter
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          if (this.map) {
            this.map.setCenter(this.currentLocation)
          }
          this._setupFullscreenControls(document.querySelector('.full-icon'))
        },
        (error) => {
          // 定位失败，地图已初始化为默认
          this._setupFullscreenControls(document.querySelector('.full-icon'))
        },
        { timeout: 3000 }
      )
    } else {
      // 不支持定位，地图已初始化为默认
      this._setupFullscreenControls(document.querySelector('.full-icon'))
    }
  }

  _setupFullscreenControls(fullIcon) {
    if (fullIcon) {
      // Add fullscreen control to map in normal mode
      const fullscreenControlDiv = document.createElement('div')
      const normalModeIcon = fullIcon.cloneNode(true)
      fullscreenControlDiv.appendChild(normalModeIcon)
      this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(fullscreenControlDiv)

      // Add click event to both icons
      ;[fullIcon, normalModeIcon].forEach((icon) => {
        icon.addEventListener('click', () => {
          const mapElement = document.getElementById('map')
          if (!document.fullscreenElement) {
            mapElement.requestFullscreen()
          } else {
            document.exitFullscreen()
          }
        })
      })

      // Handle fullscreen changes
      document.addEventListener('fullscreenchange', () => {
        const isFullscreen = !!document.fullscreenElement
        const mapContainer = document.querySelector('.map-container')

        if (isFullscreen) {
          mapContainer.classList.add('fullscreen')
        } else {
          mapContainer.classList.remove('fullscreen')
        }
      })
    }
  }

  _initializeMap() {
    if (!this.map && typeof google !== "undefined") {
      const mapElement = document.getElementById('map')
      if (!mapElement) return
      const addressInput = document.getElementById('address-input')

      this.map = new google.maps.Map(mapElement, {
        center: this.currentLocation,
        zoom: 15,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: true,
        gestureHandling: 'greedy',
        disableDefaultUI: true
      })

      // Add marker at current location
      const marker = new google.maps.Marker({
        position: this.currentLocation,
        map: this.map,
        title: 'Your Location',
        draggable: true
      })

      // Add click listener to map
      this.map.addListener('click', (event) => {
        const clickedLocation = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        }

        // Update marker position
        marker.setPosition(clickedLocation)

        // Get address from coordinates
        const geocoder = new google.maps.Geocoder()
        geocoder.geocode({ location: clickedLocation }, (results, status) => {
          if (status === 'OK' && results[0]) {
            addressInput.value = results[0].formatted_address
            // Enable next button if address is selected
            const nextBtn = document.querySelector('.step-1 .next-btn')
            if (nextBtn) {
              nextBtn.disabled = false
            }
          }
        })
      })

      // Add dragend listener to marker
      marker.addListener('dragend', (event) => {
        const draggedLocation = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        }

        // Get address from coordinates
        const geocoder = new google.maps.Geocoder()
        geocoder.geocode({ location: draggedLocation }, (results, status) => {
          if (status === 'OK' && results[0]) {
            addressInput.value = results[0].formatted_address
            // Enable next button if address is selected
            const nextBtn = document.querySelector('.step-1 .next-btn')
            if (nextBtn) {
              nextBtn.disabled = false
            }
          }
        })
      })

      // Initialize address search
      this._initAddressSearch()
    }
  }

  _initAddressSearch() {
    const input = this.container.querySelector('#address-input')
    const suggestionsContainer = this.container.querySelector('.address-suggestions')
    const suggestionsList = this.container.querySelector('.suggestions-list')
    const searchService = new google.maps.places.AutocompleteService()
    const placesService = new google.maps.places.PlacesService(this.map)

    // Handle input changes
    let timeout = null
    input.addEventListener('input', (e) => {
      clearTimeout(timeout)
      const query = e.target.value

      if (query.length < 2) {
        suggestionsContainer.style.display = 'none'
        return
      }

      timeout = setTimeout(() => {
        searchService.getPlacePredictions(
          {
            input: query,
            types: ['address']
          },
          (predictions, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK) {
              suggestionsContainer.style.display = 'none'
              return
            }

            suggestionsList.innerHTML = ''
            predictions.forEach((prediction) => {
              const item = document.createElement('div')
              item.className = 'suggestion-item'
              item.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.20312C16 5.54627 15.4142 4.13205 14.2426 2.96048C13.0711 1.78891 11.6569 1.20312 10 1.20312C8.34315 1.20312 6.92893 1.78891 5.75736 2.96048C4.58579 4.13205 4 5.54627 4 7.20312C4 9.10375 4.94351 11.05 6.83054 13.0418C7.74429 14.0064 8.6621 14.7959 9.58397 15.4105C9.64558 15.4516 9.71181 15.4829 9.78266 15.5043C9.85352 15.5257 9.92597 15.5364 10 15.5364C10.074 15.5364 10.1465 15.5257 10.2173 15.5043C10.2882 15.4829 10.3544 15.4516 10.416 15.4105C11.3379 14.7959 12.2557 14.0064 13.1695 13.0418C15.0565 11.05 16 9.10375 16 7.20312ZM10 2.70312C11.2427 2.70312 12.3033 3.14247 13.182 4.02115C14.0607 4.89983 14.5 5.96048 14.5 7.20312C14.5 8.70528 13.6935 10.3076 12.0805 12.0102C11.3842 12.7452 10.6907 13.3656 10 13.8714C9.30931 13.3656 8.61579 12.7452 7.91946 12.0102C6.30649 10.3076 5.5 8.70528 5.5 7.20312C5.5 5.96048 5.93934 4.89983 6.81802 4.02115C7.6967 3.14247 8.75736 2.70312 10 2.70312ZM11.7678 5.43535C11.2796 4.9472 10.6904 4.70312 10 4.70312C9.30965 4.70312 8.72039 4.9472 8.23223 5.43535C7.74408 5.92351 7.5 6.51277 7.5 7.20312C7.5 7.89348 7.74408 8.48274 8.23223 8.9709C8.72039 9.45905 9.30965 9.70312 10 9.70312C10.6904 9.70312 11.2796 9.45905 11.7678 8.9709C12.2559 8.48274 12.5 7.89348 12.5 7.20312C12.5 6.51277 12.2559 5.92351 11.7678 5.43535ZM9.29289 6.49602C9.48816 6.30076 9.72386 6.20312 10 6.20312C10.2761 6.20312 10.5118 6.30076 10.7071 6.49602C10.9024 6.69128 11 6.92698 11 7.20312C11 7.47927 10.9024 7.71497 10.7071 7.91023C10.5118 8.10549 10.2761 8.20312 10 8.20312C9.72386 8.20312 9.48816 8.10549 9.29289 7.91023C9.09763 7.71497 9 7.47927 9 7.20312C9 6.92698 9.09763 6.69128 9.29289 6.49602ZM5.99443 13.8593C5.99443 13.9007 5.99104 13.9418 5.98425 13.9825C5.97746 14.0233 5.96737 14.0633 5.95398 14.1023C5.94059 14.1415 5.92408 14.1792 5.90444 14.2156C5.88481 14.252 5.86232 14.2865 5.83699 14.3191C5.81165 14.3518 5.7838 14.3822 5.75344 14.4102C5.72308 14.4383 5.69062 14.4637 5.65607 14.4863C5.62152 14.509 5.58534 14.5287 5.54753 14.5454C5.50972 14.5621 5.4708 14.5756 5.43076 14.5858L5.42934 14.5862C4.51012 14.8221 3.80118 15.1077 3.30252 15.4429C2.93417 15.6905 2.75 15.9056 2.75 16.0881C2.75 16.2272 2.86797 16.3933 3.1039 16.5865C3.43977 16.8617 3.93468 17.1125 4.58864 17.339C6.07123 17.8526 7.87501 18.1093 10 18.1093C12.125 18.1093 13.9288 17.8526 15.4114 17.339C16.0653 17.1125 16.5602 16.8617 16.8961 16.5865C17.132 16.3933 17.25 16.2272 17.25 16.0881C17.25 15.911 17.0745 15.7018 16.7234 15.4605C16.2453 15.1319 15.5626 14.8496 14.6753 14.6135C14.6356 14.603 14.5971 14.5893 14.5596 14.5724C14.5222 14.5555 14.4864 14.5357 14.4522 14.5129C14.4181 14.4902 14.386 14.4648 14.356 14.4367C14.326 14.4087 14.2985 14.3784 14.2735 14.3458C14.2484 14.3133 14.2262 14.2789 14.2069 14.2427C14.1875 14.2065 14.1712 14.169 14.158 14.1301C14.1448 14.0913 14.1348 14.0516 14.1281 14.0111C14.1214 13.9706 14.1181 13.9298 14.1181 13.8887C14.1181 13.8395 14.1229 13.7908 14.1325 13.7424C14.1421 13.6942 14.1563 13.6473 14.1752 13.6017C14.194 13.5563 14.2171 13.5131 14.2445 13.4721C14.2718 13.4311 14.3029 13.3932 14.3377 13.3584C14.3726 13.3236 14.4105 13.2925 14.4514 13.2651C14.4923 13.2378 14.5356 13.2147 14.5811 13.1958C14.6266 13.177 14.6735 13.1628 14.7218 13.1531C14.7701 13.1435 14.8188 13.1387 14.8681 13.1387C14.9334 13.1387 14.9977 13.1471 15.0609 13.1639C16.1149 13.4443 16.9525 13.7979 17.573 14.2242C18.3577 14.7636 18.75 15.3849 18.75 16.0881C18.75 17.2093 17.8008 18.0987 15.9023 18.7563C14.2607 19.325 12.2933 19.6093 10 19.6093C7.70671 19.6094 5.73926 19.3251 4.09765 18.7563C2.19922 18.0987 1.25 17.2093 1.25 16.0881C1.25 15.3729 1.65521 14.7429 2.46564 14.198C3.10737 13.7666 3.97152 13.4116 5.0581 13.1329C5.11922 13.1172 5.18133 13.1093 5.24443 13.1093C5.29368 13.1093 5.34245 13.1142 5.39075 13.1238C5.43905 13.1334 5.48595 13.1476 5.53144 13.1664C5.57694 13.1853 5.62016 13.2084 5.66111 13.2357C5.70206 13.2631 5.73994 13.2942 5.77476 13.329C5.80958 13.3639 5.84067 13.4018 5.86803 13.4427C5.89539 13.4837 5.91849 13.5269 5.93734 13.5723C5.95619 13.6179 5.97041 13.6648 5.98002 13.713C5.98963 13.7614 5.99443 13.8101 5.99443 13.8593Z" fill="#3F68E0"/>
            </svg>
              <span class="address-text">${prediction.description}</span>
            `

              item.addEventListener('click', () => {
                input.value = prediction.description
                suggestionsContainer.style.display = 'none'

                // Get place details and update map
                placesService.getDetails(
                  {
                    placeId: prediction.place_id,
                    fields: ['geometry']
                  },
                  (place, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                      this.map.setCenter(place.geometry.location)
                      this.map.setZoom(18)
                      new google.maps.Marker({
                        position: place.geometry.location,
                        map: this.map,
                        title: 'Selected Location'
                      })
                      this.container.querySelector('.next-btn').disabled = false
                    }
                  }
                )
              })

              suggestionsList.appendChild(item)
            })

            suggestionsContainer.style.display = 'block'
          }
        )
      }, 300)
    })

    // Close suggestions when clicking outside
    document.addEventListener('click', (e) => {
      if (!input.contains(e.target) && !suggestionsContainer.contains(e.target)) {
        suggestionsContainer.style.display = 'none'
      }
    })
  }

  _initSteps() {
    const container = this.container
    const nextBtns = container.querySelectorAll('.next-btn')
    const backBtns = container.querySelectorAll('.back-btn')

    nextBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.currentStep === 1) {
          // Step 1: Collect address and location data
          const addressInput = container.querySelector('#address-input')
          const mapElement = document.getElementById('map')
          const map = this.map

          if (map && map.getCenter()) {
            const geocoder = new google.maps.Geocoder()
            const latlng = map.getCenter()

            geocoder.geocode({ location: latlng }, (results, status) => {
              if (status === 'OK' && results[0]) {
                // Get country from address components
                const addressComponents = results[0].address_components
                const countryComponent = addressComponents.find((component) => component.types.includes('country'))

                this.chooseForm.latitude = latlng.lat()
                this.chooseForm.longitude = latlng.lng()
                this.chooseForm.address = addressInput.value
                this.chooseForm.country = countryComponent ? countryComponent.short_name.toLowerCase() : 'de'
              }
            })
          }

          container.querySelector('.step-1').style.display = 'none'
          container.querySelector('.step-2').style.display = 'block'
          container.querySelector('[data-step="2"]').classList.add('active')
          this.currentStep = 2
        } else if (this.currentStep === 2) {
          // Step 2: Collect energy usage data
          const familySize = container.querySelector('.custom-select .select-value').dataset.value
          const dayPercentage = container.querySelector('.day-value .percentage').textContent
          // const monthlyBill = container.querySelector('.input-with-prefix input').value;
          // const avgPrice = container.querySelectorAll('.input-with-prefix input')[1].value;

          this.chooseForm.familyStructure = parseInt(familySize)
          this.chooseForm.daytimeElectrPercentage = parseInt(dayPercentage)
          // this.chooseForm.monthElectricPriceBefore = parseFloat(monthlyBill);
          // this.chooseForm.avgElectricPrice = parseFloat(avgPrice);

          container.querySelector('.step-2').style.display = 'none'
          container.querySelector('.step-3').style.display = 'block'
          container.querySelector('[data-step="3"]').classList.add('active')
          this.currentStep = 3
        } else if (this.currentStep === 3) {
          // Step 3: Collect savings and installation preferences
          const savingsPercentage = container.querySelector('.savings-value').textContent
          const installationOptions = container.querySelectorAll('.installation-option input:checked')
          const selectedPlaces = Array.from(installationOptions).map((option) => parseInt(option.value))

          this.chooseForm.electricityPricePercentage = savingsPercentage.replace('%', '')
          this.chooseForm.solarPanelsPlace = selectedPlaces

          // 状态UI元素
          const step3Content = container.querySelector('.step-3')
          const statusBox = container.querySelector('.step-3-status')
          const loadingBox = statusBox.querySelector('.status-loading')
          const successBox = statusBox.querySelector('.status-success')
          const errorBox = statusBox.querySelector('.status-error')

          // 隐藏表单内容，显示 loading
          step3Content.style.display = 'none'
          statusBox.style.display = 'block'
          loadingBox.style.display = 'block'
          successBox.style.display = 'none'
          errorBox.style.display = 'none'

          fetch('https://api-e.ecoflow.com/app/energy-diy/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-appid': '7'
            },
            body: JSON.stringify(this.chooseForm)
          })
            .then((response) => response.json())
            .then((data) => {
              if (data && data.code == '0') {
                // 显示加载中
                // 获取diyId并请求方案
                const diyId = data.data && data.data.diyId
                if (diyId) {
                  fetch(`https://api-e.ecoflow.com/app/energy-diy/getDiyPlan?diyId=${diyId}`, {
                    method: 'GET',
                    headers: {
                      'x-appid': '7'
                    }
                  })
                    .then((resp) => resp.json())
                    .then((planData) => {
                      // 填充推荐方案卡片
                      const card = successBox.querySelector('.diy-plan-card')
                      if (!planData || !planData.data || !Array.isArray(planData.data)) {
                        card.style.display = 'block'
                        card.innerHTML = '<div style="color:#F04438;">未获取到推荐方案</div>'
                        return
                      }
                      this.bundles = planData.data
                      planData.data.forEach((item, index) => {
                        const tab = card.querySelector('.plan-tab[data-index="' + item.bundleType + '"]')
                        tab.style.display = 'block'
                        if (index == 0) {
                          this.renderBundle(item.bundleType)
                        }
                      })
                      loadingBox.style.display = 'none'
                      successBox.style.display = 'block'
                      card.style.display = 'block'
                    })
                    .catch((e) => {
                      console.log('error', e)
                      // resultBox.innerHTML = '<span style="color:#F04438;">获取方案失败</span>';
                      loadingBox.style.display = 'none'
                      errorBox.style.display = 'block'
                    })
                } else {
                  // resultBox.innerHTML = '<span style="color:#F04438;">未获取到diyId</span>';
                  loadingBox.style.display = 'none'
                  errorBox.style.display = 'block'
                }
              } else {
                loadingBox.style.display = 'none'
                errorBox.style.display = 'block'
              }
            })
            .catch((error) => {
              loadingBox.style.display = 'none'
              errorBox.style.display = 'block'
            })

          // 返回按钮事件（只绑定一次）
          statusBox.querySelectorAll('.back-btn').forEach((btn) => {
            btn.onclick = () => {
              statusBox.style.display = 'none'
              step3Content.style.display = 'none'
              container.querySelector('.step-1').style.display = 'block'
              container.querySelector('.step-2').style.display = 'none'
              container.querySelector('.step-3').style.display = 'none'
              container.querySelector('[data-step="2"]').classList.remove('active')
              container.querySelector('[data-step="3"]').classList.remove('active')
              this.currentStep = 1
              container.querySelector('.step.current').classList.remove('current')
              container.querySelectorAll('.step')[0].classList.add('current')
            }
          })
          return // 阻止后续 current step class 切换
        }
        container.querySelector('.step.current').classList.remove('current')
        container.querySelectorAll('.step')[this.currentStep - 1].classList.add('current')
      })
    })

    backBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.currentStep === 2) {
          container.querySelector('.step-1').style.display = 'block'
          container.querySelector('.step-2').style.display = 'none'
          container.querySelector('[data-step="2"]').classList.remove('active')
          this.currentStep = 1
        } else if (this.currentStep === 3) {
          container.querySelector('.step-2').style.display = 'block'
          container.querySelector('.step-3').style.display = 'none'
          container.querySelector('[data-step="3"]').classList.remove('active')
          this.currentStep = 2
        }
        container.querySelector('.step.current').classList.remove('current')
        container.querySelectorAll('.step')[this.currentStep - 1].classList.add('current')
      })
    })

    // Initialize savings slider
    this._initSavingsSlider()

    // Privacy Policy 弹窗逻辑
    const privacyLink = container.querySelector('.privacy-policy a')
    const modal = container.querySelector('.privacy-modal')
    if (privacyLink && modal) {
      privacyLink.addEventListener('click', (e) => {
        e.preventDefault()
        modal.style.display = 'flex'
      })
      modal.querySelector('.privacy-modal__close').onclick = () => {
        modal.style.display = 'none'
      }
      modal.querySelector('.privacy-modal__mask').onclick = () => {
        modal.style.display = 'none'
      }
    }
  }

  _initSavingsSlider() {
    const slider = this.container.querySelector('.savings-slider')
    if (!slider) return

    const handle = slider.querySelector('.slider-handle')
    const progress = slider.querySelector('.savings-progress')
    const value = slider.querySelector('.savings-value')
    let isDragging = false
    let startX, startLeft

    const updateSlider = (clientX) => {
      const rect = slider.getBoundingClientRect()
      let newLeft = ((clientX - rect.left) / rect.width) * 100
      newLeft = Math.max(0, Math.min(100, newLeft))

      handle.style.left = `${newLeft}%`
      progress.style.width = `${newLeft}%`
      value.textContent = `${Math.round(newLeft)}%`
      value.style.left = `${newLeft}%`
    }

    handle.addEventListener('mousedown', (e) => {
      isDragging = true
      startX = e.clientX
      startLeft = parseFloat(handle.style.left)
      handle.style.cursor = 'grabbing'
    })

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return
      e.preventDefault()
      updateSlider(e.clientX)
    })

    document.addEventListener('mouseup', () => {
      isDragging = false
      handle.style.cursor = 'grab'
    })

    // Touch events for mobile
    handle.addEventListener('touchstart', (e) => {
      isDragging = true
      startX = e.touches[0].clientX
      startLeft = parseFloat(handle.style.left)
    })

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return
      e.preventDefault()
      updateSlider(e.touches[0].clientX)
    })

    document.addEventListener('touchend', () => {
      isDragging = false
    })
  }

  _initCustomSelect() {
    const select = this.container.querySelector('.custom-select')
    if (!select) return
    const value = select.querySelector('.select-value')
    const options = select.querySelector('.select-options')
    const optionItems = select.querySelectorAll('.select-option')

    select.addEventListener('click', (e) => {
      e.stopPropagation()
      const isOpen = options.style.display === 'block'
      options.style.display = isOpen ? 'none' : 'block'
      select.classList.toggle('open', !isOpen)
    })

    optionItems.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.stopPropagation()
        value.textContent = option.textContent
        value.dataset.value = option.dataset.value
        options.style.display = 'none'
        select.classList.remove('open')
      })
    })

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!select.contains(e.target)) {
        options.style.display = 'none'
        select.classList.remove('open')
      }
    })
  }

  _initUsageSlider() {
    const slider = this.container.querySelector('.usage-slider')
    if (!slider) return
    const handle = slider.querySelector('.slider-handle')
    const dayValue = slider.querySelector('.day-value .percentage')
    const nightValue = slider.querySelector('.night-value .percentage')
    const dayBg = slider.querySelector('.day-bg')
    const nightBg = slider.querySelector('.night-bg')
    let isDragging = false
    let startX, startLeft

    const updateSlider = (clientX) => {
      const rect = slider.getBoundingClientRect()
      let newLeft = ((clientX - rect.left) / rect.width) * 100
      newLeft = Math.max(0, Math.min(100, newLeft))

      handle.style.left = `${newLeft}%`
      dayValue.textContent = `${Math.round(newLeft)}%`
      nightValue.textContent = `${Math.round(100 - newLeft)}%`

      // Update background widths
      dayBg.style.width = `${newLeft}%`
      nightBg.style.width = `${100 - newLeft}%`
    }

    handle.addEventListener('mousedown', (e) => {
      isDragging = true
      startX = e.clientX
      startLeft = parseFloat(handle.style.left)
      handle.style.cursor = 'grabbing'
    })

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return
      e.preventDefault()
      updateSlider(e.clientX)
    })

    document.addEventListener('mouseup', () => {
      isDragging = false
      handle.style.cursor = 'grab'
    })

    // Touch events for mobile
    handle.addEventListener('touchstart', (e) => {
      isDragging = true
      startX = e.touches[0].clientX
      startLeft = parseFloat(handle.style.left)
    })

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return
      e.preventDefault()
      updateSlider(e.touches[0].clientX)
    })

    document.addEventListener('touchend', () => {
      isDragging = false
    })
  }

  _initPlanTabs() {
    const card = this.container.querySelector('.diy-plan-card')
    if (!card) return

    const tabs = card.querySelectorAll('.plan-tab')
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const idx = parseInt(tab.getAttribute('data-index'))
        this.currentIndex = idx
        this.renderBundle(idx)
      })
    })

    const backBtn = card.querySelector('.plan-reselect')
    backBtn.addEventListener('click', () => {
      this._resetSteps()
    })
  }

  renderBundle(idx) {
    const card = this.container.querySelector('.diy-plan-card')
    if (!card) return

    const bundle = this.bundles[idx]
    if (!bundle) return

    // Update tab states
    card.querySelectorAll('.plan-tab').forEach((tab, index) => {
      tab.classList.toggle('active', index === idx)
    })

    if (bundle.electricEquipmentList && bundle.electricEquipmentList.length > 0) {
      let equipmentHTML = ''
      bundle.electricEquipmentList.forEach((item) => {
        equipmentHTML +=
          "<div class='electric-equipment-list__item'><span class='title'>" +
          item.equipmentName +
          "</span><span class='num'>x" +
          item.total +
          '</span></div>'
      })
      this.electricEquipmentList.innerHTML =
        "<div class='electric-equipment-list__container'>" + equipmentHTML + '</div>'
    }

    this.savePerYear.innerHTML = bundle.reducePriceYearly + ' ' + this.currencySymbol
    this.capacity.innerHTML = bundle.energyStorage
    this.electricityGenerated.innerHTML = bundle.powerGenerationYearly
    // productPics
    const bundleGallery = this.container.querySelector('.bundle-gallery')
    const mainGallery = this.container.querySelector('.product-single__media.product-single__media-recommend')
    const thumbnails = this.container.querySelector('.thumbnails-slider')
    if (bundleGallery && bundle.productPics && bundle.productPics.length) {
      this._renderBundleGallery(bundle.productPics)
      bundleGallery.style.display = 'block'
      if (mainGallery) mainGallery.style.display = 'none'
      if (thumbnails) thumbnails.style.display = 'none'
    }
    // bundleType 0 最节省 bundleType 1 最推荐
    this.container.querySelector('#plan-save-amount').innerHTML = this.currencySymbol + ' ' + bundle.reducePriceYearly
    this.container.querySelectorAll('#plan-env .percentage-num').forEach((item) => {
      if (bundle.environmentalProtection > 100) {
        item.innerHTML = '100%'
        card.querySelector('.plan-env .after-env').style.setProperty('--env-width', '0%')
      } else {
        item.innerHTML = bundle.environmentalProtection + '%'
        card
          .querySelector('.plan-env .after-env')
          .style.setProperty('--env-width', 100 - bundle.environmentalProtection + '%')
      }
    })

    this.container.querySelector('#plan-bill .bill-before .bill-label span').innerHTML =
      this.currencySymbol + bundle.electricPriceMonthly

    this.container.querySelector('#plan-bill .bill-after .bill-label span').innerHTML =
      this.currencySymbol + bundle.electricPriceMonthlyAfter

    // Update environmental contribution
    const envBadge = card.querySelector('.env-badge span')
    if (envBadge) {
      envBadge.innerHTML = bundle.envPercent + '%'
    }

    // Update bill information
    const billBefore = card.querySelector('.bill-before .bill-label span')
    const billAfter = card.querySelector('.bill-after .bill-label span')
    if (billBefore) billBefore.innerHTML = bundle.electricPriceMonthly
    if (billAfter) billAfter.innerHTML = bundle.electricPriceMonthlyAfter

    // Update progress bar width
    const billAfterBar = card.querySelector('.bill-after .bar')
    const percentage = Math.round(
      (parseInt(bundle.electricPriceMonthlyAfter) / parseInt(bundle.electricPriceMonthly)) * 100
    )
    if (billAfterBar) {
      billAfterBar.style.transform = 'translateX(calc(' + percentage + '% - 100%))'
    }

    this.container.querySelector('#plan-bill .percentage .num').innerHTML = 100 - percentage + '%'

    this.container.querySelector('#solar-panel-power').innerHTML = bundle.solarPanelPower + ' W'
    this.container.querySelector('#power-generation-yearly').innerHTML = bundle.powerGenerationYearly + ' W'
    this.container.querySelector('#energy-storage').innerHTML = bundle.energyStorage.replace(
      /(\d)([a-zA-Z]+)/g,
      '$1 $2'
    )
    this.container.querySelector('#output-power').innerHTML = bundle.outputPower.replace(/(\d)([a-zA-Z]+)/g, '$1 $2')
    this.container.querySelector('#offline-power').innerHTML = bundle.offlinePower.replace(/(\d)([a-zA-Z]+)/g, '$1 $2')
    this.container.querySelector('#bypass-power').innerHTML = bundle.bypassPower.replace(/(\d)([a-zA-Z]+)/g, '$1 $2')

    this.container.querySelector('.bundle-buy-container .price__sale .price-item--sale').innerHTML =
      bundle.price + '' + this.currencySymbol
    this.container.querySelector('.bundle-buy-container .price__sale .price-item--regular').innerHTML =
      bundle.compareAtPrice + '' + this.currencySymbol

    this.container.querySelector('#product-form__cart-submit').href = bundle.productOrderUrl

    var priceFormat = theme.priceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat
    var comparePriceFormat = theme.comparePriceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat
    var formatRegularPrice = function (regularPriceElement, price) {
      regularPriceElement.innerHTML = theme.Currency.formatMoney(price, comparePriceFormat).replace("EUR", "")
    }

    // const optionLabelIncluded = this.container.querySelector('.bundle-buy-container [data-tax-included]')
    // const optionLabelExcluded = this.container.querySelector('.bundle-buy-container [data-tax-excluded]')
    // if(variant.title.replace(/\s/g, '').includes("0%")){
    //   optionLabelIncluded.classList.add('hide')
    //   optionLabelExcluded.classList.remove('hide')
    // }else{
    //   optionLabelIncluded.classList.remove('hide')
    //   optionLabelExcluded.classList.add('hide')
    // }

    // const klarnaEle = this.container.querySelector('.bundle-buy-container .product-klarna')
    // const klarnaItem = klarnaEle.querySelector('klarna-placement')
    // if (klarnaItem) {
    //   klarnaItem.setAttribute('data-purchase-amount', bundle.price * 100.0)
    //   if (window.Klarna && window.Klarna.OnsiteMessaging) {
    //     window.Klarna.OnsiteMessaging.refresh()
    //   }
    //   if (klarnaEle && klarnaEle.dataset.info) {
    //     klarnaEle.querySelector('.info').innerHTML = klarnaEle.dataset.info.replace(
    //       '${price}',
    //       theme.Currency.formatMoney((bundle.price * 100.0) / 3.0, comparePriceFormat).replace("EUR", "")
    //     )
    //   }
    // }

    const klarnaEle = document.querySelector(".PayPal_box_content_main klarna-placement");
    const paypalEle = document.querySelector(".PayPal_box_content_main [data-pp-message]");
    const bnpEle = document.querySelector(".PayPal_box_content_main [data-bnp-message]");
    const paymentEles = document.querySelectorAll("[data-payment-trigger]");

    if(klarnaEle){
      klarnaEle.setAttribute('data-purchase-amount',  bundle.price * 100.0);
      if (window.Klarna && window.Klarna.OnsiteMessaging) {
        window.Klarna.OnsiteMessaging.refresh()
      }
    }
    window.reloadBnb?window.reloadBnb(bundle.price * 100.0):''
    if(paypalEle){
      paypalEle.setAttribute('data-pp-amount', bundle.price);
    }
    if(bnpEle){
      bnpEle.setAttribute('data-bnp-amount',totalPrice / 100.0);
    }
    if(paymentEles){
      paymentEles.forEach(paymentEle => {
        paymentEle.setAttribute('data-payment-amount',bundle.price / 100.0);
      })
    }
    if (typeof window.updatePdpIntroductionAmount === 'function') {
      window.updatePdpIntroductionAmount(bundle.price * 100.0);
    }
  }

  _renderBundleGallery(pics) {
    const gallery = this.container.querySelector('.bundle-gallery')
    if (!gallery) return

    // 清空旧内容
    gallery.innerHTML = ''

    // 构建 Flickity 结构
    const carousel = document.createElement('div')
    carousel.className = 'bundle-flickity-carousel'
    pics.forEach((url) => {
      const cell = document.createElement('div')
      cell.className = 'carousel-cell'
      cell.innerHTML = `<img src="${url}" alt="bundle image" />`
      carousel.appendChild(cell)
    })
    gallery.appendChild(carousel)

    // 销毁旧实例
    if (gallery.flickityInstance) {
      gallery.flickityInstance.destroy()
    }
    gallery.flickityInstance = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
      imagesLoaded: true
    })
  }

  _initFormContent() {
    const container = this.container

    // Initialize step 2 content
    const familySizeSelect = container.querySelector('.custom-select .select-value')
    if (familySizeSelect) {
      familySizeSelect.dataset.value = this.chooseForm.familyStructure
    }

    const dayPercentage = container.querySelector('.day-value .percentage')
    if (dayPercentage) {
      dayPercentage.textContent = `${this.chooseForm.daytimeElectrPercentage}%`
    }

    // const monthlyBillInput = container.querySelector('.input-with-prefix input');
    // if (monthlyBillInput) {
    //   monthlyBillInput.value = this.chooseForm.monthElectricPriceBefore;
    // }

    // const avgPriceInput = container.querySelectorAll('.input-with-prefix input')[1];
    // if (avgPriceInput) {
    //   avgPriceInput.value = this.chooseForm.avgElectricPrice;
    // }

    // Initialize step 3 content
    const savingsSlider = container.querySelector('.savings-slider')
    if (savingsSlider) {
      const savingsProgress = savingsSlider.querySelector('.savings-progress')
      const savingsHandle = savingsSlider.querySelector('.slider-handle')
      const savingsValue = savingsSlider.querySelector('.savings-value')

      if (savingsProgress && savingsHandle && savingsValue) {
        savingsProgress.style.width = `${this.chooseForm.electricityPricePercentage}%`
        savingsHandle.style.left = `${this.chooseForm.electricityPricePercentage}%`
        savingsValue.textContent = `${this.chooseForm.electricityPricePercentage}%`
      }
    }

    // Initialize installation options
    const installationOptions = container.querySelectorAll('.installation-option input')
    if (installationOptions) {
      installationOptions.forEach((option) => {
        const value = parseInt(option.value)
        option.checked = this.chooseForm.solarPanelsPlace.includes(value)
      })
    }
  }

  // 初始化数量按钮
  _initQuantityButtons() {
    // 获取所有减少按钮
    const decreaseBtns = this.container.querySelectorAll('.quantity-decrease')

    // 获取所有增加按钮
    const increaseBtns = this.container.querySelectorAll('.quantity-increase')

    // 为减少按钮添加事件
    decreaseBtns.forEach((btn) => {
      btn.onclick = (e) => {
        e.preventDefault()
        e.stopPropagation()

        const valueSpan = btn.nextElementSibling
        if (!valueSpan || btn.classList.contains('disabled')) {
          return
        }

        let value = parseInt(valueSpan.textContent || '1')


         const accessoriesOption = btn.closest(".accessory-option-checked")
         if(accessoriesOption){
            if (value > 0) {
              value--
              valueSpan.textContent = value

              if(value == 0){
                accessoriesOption.querySelector('input[type="checkbox"]').checked = false;
                accessoriesOption.querySelector('input[type="checkbox"]').dispatchEvent(new Event('change'));
              }

              if(btn.closest(".guess-items-v2")){
                this._updatePrice()
              }else{
                this._updateProductSummary()
              }
            }
            
         }else{
          if (value > 1) {
            value--
            valueSpan.textContent = value

            if(btn.closest(".guess-items-v2")){
              this._updatePrice()
            }else{
              this._updateProductSummary()
            }
          }
         }

         if(value == 0){
          btn.classList.add('disabled');
         }else{
          btn.parentElement.querySelector('.quantity-increase').classList.remove('disabled');
         }
      }
    })

    // 为增加按钮添加事件
    increaseBtns.forEach((btn) => {
      btn.onclick = (e) => {
        e.preventDefault()
        e.stopPropagation()

        const valueSpan = btn.previousElementSibling
        if (!valueSpan || btn.classList.contains('disabled')) {
          return
        }

        const batteryOption = btn.closest(".battery-option")
        if(batteryOption){
          if(document.querySelector(".battery-options-info .num").textContent == "0"){
            return;
          }
        }
        
        let value = parseInt(valueSpan.textContent || '1')

        value++
        if(btn.closest('.embed-item:not(:has(input:checked))')){
          btn.closest('.embed-item').click();
        }
        valueSpan.textContent = value

        if(value == 99){
          btn.classList.add('disabled');
        }else{
          btn.parentElement.querySelector('.quantity-decrease').classList.remove('disabled');
        }

        if(btn.closest(".guess-items-v2")){
          this._updatePrice()
        }else{
          this._updateProductSummary()
        }
      }
    })
  }

  _initBenefitsShowMore() {
    const benefitsContainer = this.container.querySelector('.product-benefits')
    if (!benefitsContainer) return

    const benefitItems = benefitsContainer.querySelectorAll('.product-benefits__item')
    if (benefitItems.length <= 6) return

    benefitItems.forEach((item, index) => {
      if (index >= 6) {
        item.classList.add('hidden')
      }
    })

    const showMoreBtn = document.createElement('div')
    showMoreBtn.className = 'product-benefits__show-more'
    showMoreBtn.innerHTML =
      '<span>' +
      benefitsContainer.dataset.showMore +
      '</span> <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="#909090" stroke-width="1.5" stroke-linecap="round"/></svg>'

    benefitsContainer.appendChild(showMoreBtn)

    let expanded = false
    showMoreBtn.addEventListener('click', () => {
      expanded = !expanded

      if (expanded) {
        benefitItems.forEach((item) => {
          item.classList.remove('hidden')
        })
        showMoreBtn.querySelector('span').textContent = benefitsContainer.dataset.showLess
        showMoreBtn.classList.add('expanded')
      } else {
        benefitItems.forEach((item, index) => {
          if (index >= 6) {
            item.classList.add('hidden')
          }
        })
        showMoreBtn.querySelector('span').textContent = benefitsContainer.dataset.showMore
        showMoreBtn.classList.remove('expanded')
      }
    })
  }

  initCountdown() {
    const countdownElements = document.querySelectorAll('[data-count-down]')
    
    if (countdownElements.length === 0) {
      return
    }

    countdownElements.forEach(element => {
      const countdownText = element.getAttribute('data-count-down')
      if (countdownText) {
        this.startCountdown(element, countdownText)
      }
    })
  }

  startCountdown(element, dateString) {
    const targetDate = new Date(dateString)
    
    if (isNaN(targetDate.getTime())) {
      console.error('Invalid date format:', dateString)
      return
    }

    const endsInText = element.getAttribute('data-ends-in') || 'Ends in'
    const daysTitle = element.getAttribute('data-days-title') || 'Days'

    /** InsCoder WANG.J 2026-09-15 B + Render the scoped Figma countdown as localized, individually styled units. **/
    const hoursTitle = element.getAttribute('data-hours-title') || 'Hours'
    const minutesTitle = element.getAttribute('data-minutes-title') || 'Minutes'
    const secondsTitle = element.getAttribute('data-seconds-title') || 'Seconds'
    const isFigmaCampaignTimer = element.matches('.product-code-banner--figma-campaign .summer-sale-coupon__timer')
    const timerValueElements = isFigmaCampaignTimer
        ? element.querySelectorAll('[data-countdown-unit]')
        : []
    /** InsCoder WANG.J 2026-09-15 E + Render the scoped Figma countdown as localized, individually styled units. **/

    const updateCountdown = () => {
      const now = new Date().getTime()
      const distance = targetDate.getTime() - now

      if (distance < 0) {
        element.textContent = element.getAttribute('data-expired') || 'Expired'
        if (element.countdownInterval) {
          clearInterval(element.countdownInterval)
          element.countdownInterval = null
        }
        return
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

      if (isFigmaCampaignTimer) {
        const countdownValues = { days, hours, minutes, seconds }
        timerValueElements.forEach((valueElement) => {
          const unit = valueElement.getAttribute('data-countdown-unit')
          valueElement.textContent = String(countdownValues[unit] || 0).padStart(2, '0')
        })
        element.setAttribute(
            'aria-label',
            endsInText + ' ' + days + ' ' + daysTitle + ', ' + hours + ' ' + hoursTitle + ', ' + minutes + ' ' + minutesTitle + ', ' + seconds + ' ' + secondsTitle
        )
        return
      }


      let displayText
      if (days > 0) {
        displayText = `${endsInText} ${days} ${daysTitle} ${formattedTime}`
      } else {
        displayText = `${endsInText} ${formattedTime}`
      }
      
      element.textContent = displayText
    }

    updateCountdown()

    if (targetDate.getTime() <= Date.now()) {
      return
    }
    
    const interval = setInterval(updateCountdown, 1000)
    
    element.countdownInterval = interval
  }
}
if (!window.customElements.get('powerstream-v6')) {
  window.customElements.define('powerstream-v6', PowerstreamV6)
}


document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.cust-powerstream-v6');

    sections.forEach(section => {

    function setMaxItemHeight(section, itemSelector, cssVarName) {
      if (!section) return;
      const items = section.querySelectorAll(itemSelector);
      if (!items.length) return;
      let maxH = 0;
      items.forEach(el => {
        const h = el.offsetHeight;
        if (h > maxH) maxH = h;
      });
      items.forEach(el => {
        el.style.setProperty(cssVarName, maxH + 'px');
      });
    }

    setMaxItemHeight(section, '.product-params__item .title', '--max-params-item-title-height');

    });
});
